import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DirectionsIcon from '@mui/icons-material/Directions';
import EmojiObjectsIcon from '@mui/icons-material/EmojiObjects';
import EmojiObjectsOutlinedIcon from '@mui/icons-material/EmojiObjectsOutlined';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Link from '@mui/material/Link';
import MessageIcon from '@mui/icons-material/Message';
import MenuItem from '@mui/material/MenuItem';
import RefreshIcon from '@mui/icons-material/Refresh';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import ScannerIcon from '@mui/icons-material/Scanner';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import RouteToEmployeeIcon from '@mui/icons-material/AssignmentInd';
import Select from '@mui/material/Select';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import Zoom from '@mui/material/Zoom';
import GadgetLoader from "../Loaders/GadgetLoader";
import { toast } from 'react-toastify';
import { formatNumber, defaultStringIfNullOrEmpty, stringIsNullOrEmpty, checkForUnAuthorizedException, formatDate } from '../Common/Utilities';
import { httpGet, httpPost, httpPut, httpDelete } from '../../HttpRequestHandling/httpRequestHandler';
import { InvoiceDocumentViewer } from '../InvoiceDocument/InvoiceDocumentViewer';
import { InvoiceDocumentEditor } from '../InvoiceDocument/InvoiceDocumentEditor';
import { POHeaderResourceLookup } from '../Lookups/POHeaderResourceLookup';
import { Level2ResourceLookup } from '../Lookups/Level2ResourceLookup';
import InvoiceDocumentPartialPostLookup from '../Lookups/InvoiceDocumentPartialPostLookup';
import { fileUpload } from '../NonMappedInvoices/ManualUploadApi';
import { green, orange } from '@mui/material/colors';
import EnhancedDataGrid from '../Common/EnhancedDataGrid';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import './Dashboard.css'
import TopLeftGadget from './Gadgets/TopLeftGadget';
import TopRightGadget from './Gadgets/TopRightGadget';
import BottomLeftGadget from './Gadgets/BottomLeftGadget';
import BottomRightGadget from './Gadgets/BottomRightGadget';
import { VendorMapEditorDetailDialog } from '../VendorMap/VendorMapDetailDialog';
import { InvoiceModelSetup } from '../InvoiceModels/InvoiceModelSetup/InvoiceModelSetup';
import { Constants } from '../Common/Constants';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import SearchIcon from '@mui/icons-material/Search';
import { MUIButton } from '../Common/Components/MuiButton';
import { getFilter, setFilter, getInvoiceModuleName } from '../Common/Utilities';
import { DialogContentText } from '@mui/material';
import { isNewUi } from '../../redesign/uiMode';
import DashboardPipeline from '../../redesign/dashboard/DashboardPipeline';

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Zoom in={true} ref={ref} {...props} />;
});
const spacing = 1;
const fontSize = 12;
const cellStyle = { fontSize: fontSize, padding: 8 };
const headerStyle = { fontSize: fontSize, padding: 8 };
const fontStyle = { fontSize: fontSize, padding: 8 };
const gridCss = { height: 390, width: '100%' };
const gridCssFullScreen = { height: '100%', width: '100%' };
const DEFAULT_WEEKS = -1;
export default class Dashboard extends React.Component {

	constructor() {
		super();
		this.callsInProgress = 0;
		this.isFullscreen = false;
		// Fix 3: tracks latest fetch sequence per invoiceDocumentId so stale/out-of-order
		// responses (e.g. editor-close fetch racing the reload button) are discarded.
		this._rowFetchSequence = {};
		const userInfo = JSON.parse(localStorage.userInfo);
		this.companyCode = userInfo.companyCode;
		this.isAdmin = userInfo.selectedUserRoles.isAdmin;
		this.userRoleId = userInfo.selectedUserRoles.userRoleId;
		this.selectedRows = [];
		this.scanSelectedRows = [];
		var openInvoiceDocumentEditorDialog = false;
		var rowData = null;
		const queryString = window.location.search;
		const urlParams = new URLSearchParams(queryString);
		const invoiceDocumentId = urlParams.get('invoicedocumentid');
		const status = urlParams.get('status');
		var mode = urlParams.get('mode');
		var modelDefId = urlParams.get('modeldefid');
		//const companyCode = userInfo.companyCode ?? null;
		if (!stringIsNullOrEmpty(invoiceDocumentId)) {
			openInvoiceDocumentEditorDialog = true;
			rowData = { invoiceDocumentId: parseInt(invoiceDocumentId), invoiceDocumentStatusId: parseInt(status) };
			mode = stringIsNullOrEmpty(mode) ? "MakeCorrections" : mode;
			//modelDefId = modelDefId;
		}
		if (!stringIsNullOrEmpty(modelDefId)) {
			modelDefId = modelDefId;
		}
		this.state = {
			rowReloading: {},
			downloadingInvoices: {},
			openDelete: false,
			documentManualUploadRecordIdsToDelete: '',
			deleteSelectionCount: 0,
			deleteGadgetNumber: 1,
			highlightedInvoiceDocumentId: null,
			isDefaultDBNoFilter: { 1: false, 2: false, 3: false, 4: false },
			weeksToFilter1: DEFAULT_WEEKS,
			weeksToFilter2: DEFAULT_WEEKS,
			weeksToFilter3: DEFAULT_WEEKS,
			weeksToFilter4: DEFAULT_WEEKS,
			gadgetLoading: {
				1: false,
				2: false,
				3: false,
				4: false
			},
			hasSearchedOnceByUser: {
				1: false,
				2: false,
				3: false,
				4: false,
			},
			isWeeksFromStorage: { 1: false, 2: false, 3: false, 4: false },
			hasAppliedDBWeeks: { 1: false, 2: false, 3: false, 4: false },
			suppressExpandOnce: { 1: false, 2: false, 3: false, 4: false },
			initialLoad: { 1: true, 2: true, 3: true, 4: true },
			userHasSetWeeks: { 1: false, 2: false, 3: false, 4: false },
			queuedInvoices: [],
			unmatchedInvoices: [],
			filteredUnmatchedInvoices: [],
			pendingApprovalInvoices: [],
			approvedInvoices: [],
			openInvoiceViewer: false,
			openInvoiceDocumentEditorDialog: openInvoiceDocumentEditorDialog,
			openPOHeaderResourceDialog: false,
			openLevel2ResourceDialog: false,
			rowData: rowData,
			mode: mode,
			modelDefId: modelDefId,
			isViaQueryString: !stringIsNullOrEmpty(invoiceDocumentId),
			selectedRoutedToResourceId: "-1",
			selectedRoutedToResourceName: "",
			distinctRoutedToResourceList: [],
			selectedFiles: null,
			openDashViewer: false,
			showGadget: 0,
			pageSize: 5,
			rowsPerPage: [5, 10, 20, 30, 40, 50],
			VendorMapDialogOpen: false,
			dragging: false,
			userRoleName: userInfo.selectedUserRoles.userRoleName,
			source: '',
			isExpanded: false,
			openInvoiceModelSetupDialog: false,
			invoiceDocumentSampleFileLocation: '',
			filterText: {
				1: '',
				2: '',
				3: '',
				4: ''
			},
			sortModel: {
				1: [],
				2: [],
				3: [],
				4: [],
			},
			prevSearchText: {
				1: '',
				2: '',
				3: '',
				4: ''
			},
			serverMode: {
				1: false,
				2: false,
				3: false,
				4: false,
			},
			hasTriggeredInitialAutoExpand: {
				1: false,
				2: false,
				3: false,
				4: false
			},
			switchToFullScreen: false,
			isAllowRoutingSetup: false,
			isAllowApprovalRoutingSetup: false,
			openPartialPostDialog: false,
			partialPostInvoiceDocumentId: null,
			partialPostDialogMode: 'view',
			repostRuleEditable: false,
			deletePermission: false,
			partialSelectedRows: null,
		};

		this.toolTipMessage = 'Displaying data from the last 9 weeks. Use filter and click Search to find specific invoices';

		this.invoiceQueueGridRef = React.createRef();
		this.invoiceUnmatchedGridRef = React.createRef();
		this.invoicePendingApprovalGridRef = React.createRef();
		this.invoiceApprovedGridRef = React.createRef();

		this.weeksToFilter_changeHandler = this.weeksToFilter_changeHandler.bind(this);
		this.routedToResourceList_changeHandler = this.routedToResourceList_changeHandler.bind(this);
		this.bulkRouteToEmployee_clickHandler = this.bulkRouteToEmployee_clickHandler.bind(this);
		this.bulkApprovalRouting_clickHandler = this.bulkApprovalRouting_clickHandler.bind(this);
		this.poHeaderResourceDialog_closeHandler = this.poHeaderResourceDialog_closeHandler.bind(this);
		this.level2ResourceDialog_closeHandler = this.level2ResourceDialog_closeHandler.bind(this);
		this.refresh_clickHandler = this.refresh_clickHandler.bind(this);
		this.fileUpload_clickHandler = this.fileUpload_clickHandler.bind(this);
		this.fileUpload_changeHandler = this.fileUpload_changeHandler.bind(this);
		this.viewLink_clickHandler = this.viewLink_clickHandler.bind(this);
		this.scan_clickHandler = this.scan_clickHandler.bind(this);
		this.scan_clickAIHandler = this.scan_clickAIHandler.bind(this);
		this.scanAll_clickHandler = this.scanAll_clickHandler.bind(this);
		this.invoiceDocument_clickHandler = this.invoiceDocument_clickHandler.bind(this);
		this.suggestionFlag_clickHandler = this.suggestionFlag_clickHandler.bind(this);
		this.closeDialog = this.closeDialog.bind(this);
		this.invoiceDocumentEditor_closeHandler = this.invoiceDocumentEditor_closeHandler.bind(this);
		this.showFullScreen = this.showFullScreen.bind(this);
		this.invoiceDocumentRescan_clickHandler = this.invoiceDocumentRescan_clickHandler.bind(this);
		this.getDiscrepentInvoiceLink = this.getDiscrepentInvoiceLink.bind(this);
		this.vendorMapDialog_closeHandler = this.vendorMapDialog_closeHandler.bind(this);
		this.handleDragOver = this.handleDragOver.bind(this);
		this.handleDragLeave = this.handleDragLeave.bind(this);
		this.handleDrop = this.handleDrop.bind(this);
		this.overrideRouting_clickHandler = this.overrideRouting_clickHandler.bind(this);
		this.invoiceModelSetup_closeHandler = this.invoiceModelSetup_closeHandler.bind(this);
		this.invoiceDocument_mapmodel_clickhandler = this.invoiceDocument_mapmodel_clickhandler.bind(this);
		this.inProgress = this.inProgress.bind(this);
		this.setFilterText = this.setFilterText.bind(this);
		this.getFilterText = this.getFilterText.bind(this);
		this.getOpenInFullScreenButton = this.getOpenInFullScreenButton.bind(this);
		this.getWeeksToFilterDropDown = this.getWeeksToFilterDropDown.bind(this);
		this.getScanButton = this.getScanButton.bind(this);
		this.getDeleteButton = this.getDeleteButton.bind(this);
		this.getUploadButton = this.getUploadButton.bind(this);
		this.getFullScreenState = this.getFullScreenState.bind(this);
		this.getSearchButton = this.getSearchButton.bind(this);
		this.getGridRef = this.getGridRef.bind(this);
		this.setStateAsync = this.setStateAsync.bind(this);
		this.initializeFiltersFromStorage = this.initializeFiltersFromStorage.bind(this);
		this.setSortModel = this.setSortModel.bind(this);
		this.isInvoiceRowReloading = this.isInvoiceRowReloading.bind(this);
		this.getDashboardRowClassName = this.getDashboardRowClassName.bind(this);
		this.handleDashboardRowClick = this.handleDashboardRowClick.bind(this);
		this.openInvoiceFromRow = this.openInvoiceFromRow.bind(this);
		this.openDeleteDialog = this.openDeleteDialog.bind(this);
		this.deleteYes_clickHandler = this.deleteYes_clickHandler.bind(this);
		this.bulkDeleteUnmatchedInvoices_clickHandler = this.bulkDeleteUnmatchedInvoices_clickHandler.bind(this);

	}

	isInvoiceRowReloading(invoiceDocumentId) {
		if (!invoiceDocumentId) return false;
		return !!this.state.rowReloading?.[invoiceDocumentId];
	}

	getDashboardRowClassName = (params) => {
		const invoiceDocumentId = params?.row?.invoiceDocumentId;
		const classes = [];
		if (invoiceDocumentId && invoiceDocumentId === this.state.highlightedInvoiceDocumentId) {
			classes.push('dashboard-highlighted-row');
		}
		if (invoiceDocumentId && this.isInvoiceRowReloading(invoiceDocumentId)) {
			classes.push('dashboard-row-loading');
		}
		return classes.join(' ');
	};

	fetchRepostRuleEditable(companyCode, userRoleId, modelDefId) {
		httpGet(`/api/usergrouprules/${companyCode}/${userRoleId}`)
			.then((res) => {
				const rules = res.data || [];
				const repostRule = rules.find(r =>
					r.label === 'Repost Invoice' &&
					r.Model_def_id === modelDefId &&
					r.editable === '1'
				);
				const editRule = rules.find(r =>
					r.label === 'Delete Invoice' &&
					r.Model_def_id === modelDefId &&
					r.editable === '1'
				);
				this.setState({ repostRuleEditable: !!repostRule, deletePermission: !!editRule });
			})
			.catch(() => {
				this.setState({ repostRuleEditable: false, deletePermission: false });
			});
	}

	isPartiallyPostedRow(row) {
		if (!row) return false;
		// statusId 170 + "partial" in pendingStatus = partially posted (not fully posted yet)
		if (row.invoiceDocumentStatusId !== 170) return false;
		const status = (row.pendingStatus || '').toLowerCase();
		return status.includes('partial');
	}

	openPartialPostDialogForRow(row) {
		const invoiceDocumentId = row?.invoiceDocumentId;
		if (!invoiceDocumentId) return;
		this.setState({
			openPartialPostDialog: true,
			partialPostInvoiceDocumentId: invoiceDocumentId,
			partialPostDialogMode: this.state.repostRuleEditable ? '' : 'view',
			partialPostRow: row,
		});
	}

	openInvoiceFromRow(rowData, invoiceSource, mode) {
		if (!rowData) return;
		if (mode === 'Map Vendor') {
			this.setState({ VendorMapDialogOpen: true, rowData: rowData, isViaQueryString: false, showSearchTooltip: false });
			return;
		}
		this.setState({
			openInvoiceDocumentEditorDialog: true,
			mode: mode,
			rowData: rowData,
			invoiceSource: invoiceSource,
			isViaQueryString: false,
			showSearchTooltip: false,
			editorSourceOverride: invoiceSource
		});
	}

	handleDashboardRowClick(gadgetNo, params, event) {
		const row = params?.row;
		if (!row) return;

		// Don't open editor when user interacts with links / buttons / checkboxes inside the row.
		const target = event?.target;
		if (target && typeof target.closest === 'function') {
			if (target.closest('a') || target.closest('button') || target.closest('[role="checkbox"]') || target.closest('.MuiDataGrid-checkboxInput')) {
				return;
			}
		}

		if (this.isInvoiceRowReloading(row.invoiceDocumentId)) return;

		// Determine mode per gadget
		if (gadgetNo === 2) {
			let mode = 'MakeCorrections';
			if (row.invoiceDocumentStatusId === 10 && row.vendorMappingId && row.scanServiceId === 0) {
				mode = 'Map Vendor';
			}
			this.openInvoiceFromRow(row, 'unmatchedInvoices', mode);
			return;
		}

		if (gadgetNo === 3) {
			const mode = (row.approvalLinkText && row.approvalLinkText.length > 0) ? 'Approval' : 'View';
			this.openInvoiceFromRow(row, 'pendingApprovalInvoices', mode);
			return;
		}

		if (gadgetNo === 4) {
			// If posting is in a terminal/locked state (30 = post failed/processing),
			// open as read-only View with no source so the editor doesn't try to load
			// gadget-specific actions.
			if (Number(row?.invoiceDocumentPostingStatusId) === 30) {
				this.setState({ editorSourceOverride: null });
				const rowForEditor = { ...row, status: Constants.POST_IN_PROGRESS };
				this.openInvoiceFromRow(rowForEditor, '1', Constants.VIEW);
				return;
			}

			// Partially posted rows open the partial post dialog instead of the editor
			if (this.isPartiallyPostedRow(row)) {
				this.openPartialPostDialogForRow(row);
				return;
			}

			let mode = Constants.VIEW;
			const statusMaxed = ((((row?.routingNumberOfApprovals || 0)) * 20) + 50) <= (row?.invoiceDocumentStatusId || 0);
			const applyToInvoiceDoucmentId = row?.applyToInvoiceDocumentId || 0;
			const editLinkDisplay = this.isAdmin
				&& (this.props?.modelDefId === 2 || this.props?.modelDefId === 1)
				&& statusMaxed
				&& ((row?.invoiceDocumentStatusId || 0) < 170);

			if (applyToInvoiceDoucmentId > 0) {
				mode = Constants.CREDIT_MEMO;
			} else {
				if (editLinkDisplay) {
					mode = Constants.EDIT_DATES;
				}
				if (editLinkDisplay && (row?.approvedBy || '').indexOf(Constants.SYSTEM) !== -1) {
					mode = Constants.OVERRIDE;
				}
			}
			this.openInvoiceFromRow(row, 'approvedInvoices', mode);
			return;
		}
	}

	initializeFiltersFromStorage() {
		return new Promise((resolve) => {

			const filters = getFilter([getInvoiceModuleName(this.props.modelDefId), 'Dashboard']) || {};


			let updatedState = { filterText: {}, sortModel: {} };

			for (let gadget = 1; gadget <= 4; gadget++) {

				const weeksKey = `weeksToFilter${gadget}`;
				const searchKey = `searchText${gadget}`;
				const sortKey = `sortModel${gadget}`;

				const weeksVal = filters[weeksKey];
				const searchVal = filters[searchKey];
				const sortVal = filters[sortKey];

				const normalizedWeeks = (weeksVal !== undefined && weeksVal !== '' && weeksVal !== null) ? parseInt(weeksVal, 10) : DEFAULT_WEEKS;

				if (!updatedState.initialLoad) updatedState.initialLoad = { 1: true, 2: true, 3: true, 4: true };
				const weeksExists = (weeksVal !== undefined && weeksVal !== '' && weeksVal !== null);
				updatedState.initialLoad[gadget] = weeksExists ? false : true;
				updatedState[weeksKey] = normalizedWeeks;
				if (!updatedState.userHasSetWeeks) updatedState.userHasSetWeeks = {};
				updatedState.userHasSetWeeks[gadget] = weeksExists ? true : false;
				updatedState.filterText[gadget] = searchVal || '';
				updatedState.sortModel[gadget] = sortVal || [];

				if (normalizedWeeks === 0 && searchVal?.trim()) {
					if (!updatedState.prevSearchText) updatedState.prevSearchText = {};
					updatedState.prevSearchText[gadget] = searchVal;
				}
			}

			const routedInfo = filters.selectedRoutedToResourceId2;
			if (routedInfo?.routedToResourceId) {
				updatedState.selectedRoutedToResourceId = routedInfo.routedToResourceId;
				updatedState.selectedRoutedToResourceName = routedInfo.routedTo;
			}

			this.setState(updatedState, resolve);
		});
	}

	upsertInvoiceRow(existingRows, responseRows, invoiceDocumentId) {
		if (!invoiceDocumentId || !Array.isArray(responseRows) || responseRows.length === 0) {
			return existingRows;
		}

		const updatedRow = responseRows.find(
			row => row.invoiceDocumentId === invoiceDocumentId
		);

		if (!updatedRow) return existingRows;

		const exists = existingRows.some(
			row => row.invoiceDocumentId === invoiceDocumentId
		);


		if (exists) {
			return existingRows.map(row =>
				row.invoiceDocumentId === invoiceDocumentId
					? { ...row, ...updatedRow }
					: row
			);
		}

		return [
			updatedRow,
			...existingRows
		];
	}



	fetchDashboard(gadgetNo, weeks, search, clear, invoiceDocumentId = null, resetGadgetToFirstPage = false, isAvailableForRescaning = false,
		applyToInvoiceDocumentId = null) {
		const that = this;
		const modelDefId = this.props.modelDefId;
		const gadgetNumber = gadgetNo;
		const weeksToFilter = weeks;
		const usedAuto = (weeksToFilter === -1);

		if (isAvailableForRescaning && gadgetNo === 4) {
			this.setState(prev => ({
				gadgetLoading: { ...prev.gadgetLoading, [gadgetNo]: true }
			}));
		}


		if (!invoiceDocumentId) {
			this.setState({ highlightedInvoiceDocumentId: null });
			this.setState(prevState => ({
				gadgetLoading: { ...prevState.gadgetLoading, [gadgetNo]: true },
				showSearchTooltip: false //  reset before fetching
			}));
		} else {
			// Single-row refresh: avoid blocking the entire gadget.
			this.setState(prev => ({
				rowReloading: { ...prev.rowReloading, [invoiceDocumentId]: true },
				highlightedInvoiceDocumentId: invoiceDocumentId,
				applyToInvoiceDocumentId: applyToInvoiceDocumentId,
				showSearchTooltip: false
			}));
		}

		const isClientMode = weeksToFilter !== 0 || (weeksToFilter === 0 && this.state.isDefaultDBNoFilter[gadgetNo]);
		const searchFilter = (isClientMode || clear) ? '' : search;
		const gridTitles = {
			1: "Invoice Queue (waiting to be scanned)",
			2: "Unmatched/Discrepant Invoices",
			3: "Pending Approval",
			4: "Approved Invoices"
		};
		const gridTitle = gridTitles[gadgetNumber] || " ";
		//const _weeksToFilter = (this.state.switchToFullScreen && this.state.showGadget === gadgetNumber && weeksToFilter === 0) ? 9 : weeksToFilter;

		// Fix 3: stamp a sequence number for single-row fetches on gadget 4 so that if two
		// requests race (e.g. editor-close + reload button), the older response is discarded.
		let thisSeq = null;
		if (invoiceDocumentId && gadgetNumber === 4) {
			if (!this._rowFetchSequence[invoiceDocumentId]) {
				this._rowFetchSequence[invoiceDocumentId] = 0;
			}
			this._rowFetchSequence[invoiceDocumentId]++;
			thisSeq = this._rowFetchSequence[invoiceDocumentId];
		}

		let apiUrl = `/api/dashboard/${modelDefId}/${gadgetNumber}/${weeksToFilter}`;
		if (invoiceDocumentId) {
			apiUrl += `?invoiceDocumentId=${invoiceDocumentId}`;
		}
		else if (searchFilter) {
			apiUrl += `?searchFilter=${encodeURIComponent(searchFilter)}`;
			if (gadgetNumber === 2 && this.state.selectedRoutedToResourceId !== "-1") {
				apiUrl += `&routedToResourceId=${encodeURIComponent(this.state.selectedRoutedToResourceId)}`;
			}
		}
		if ((searchFilter || '').trim() !== '' && weeksToFilter === 0 && this.state.prevSearchText[gadgetNumber] !== search) {
			this.setState(prev => ({
				hasSearchedOnceByUser: {
					...prev.hasSearchedOnceByUser,
					[gadgetNo]: true
				},
				prevSearchText: {
					...prev.prevSearchText,
					[gadgetNo]: searchFilter
				}
			}));
		}

		httpGet(apiUrl)
			.then((response) => {
				// Fix 3: if a newer request for this row is already in-flight or has completed,
				// discard this stale response entirely — only applies to gadget 4 row-level refreshes.
				if (gadgetNumber === 4 && invoiceDocumentId && thisSeq !== null
					&& this._rowFetchSequence[invoiceDocumentId] !== thisSeq) {
					return;
				}

				const data = response.data;

				let {
					weeksToFilter1,
					weeksToFilter2,
					weeksToFilter3,
					weeksToFilter4,
					queuedInvoices,
					unmatchedInvoices,
					filteredUnmatchedInvoices,
					pendingApprovalInvoices,
					approvedInvoices,
					isAllowRoutingSetup,
					isAllowApprovalRoutingSetup,
					distinctRoutedToResourceList
				} = that.state;

				switch (gadgetNumber) {
					case 1:
						queuedInvoices = data?.queuedInvoices?.listOfItems;
						const weeksFilter1 = data?.queuedInvoices?.weeksFilter;
						that.setRowId(queuedInvoices);
						queuedInvoices.forEach(row => row.invoiceDocumentFileLocation = row.documentManualUploadFileLocation);
						{
							const firstWeeksFilter = weeksFilter1;
							const shouldUseDb = usedAuto || this.state.initialLoad[1] === true;
							const rawWeeks = firstWeeksFilter;
							const parsedWeeks = (rawWeeks == null) ? null
								: (typeof rawWeeks === 'number' ? rawWeeks : parseInt(String(rawWeeks), 10));
							const nextWeeks = shouldUseDb ? (Number.isFinite(parsedWeeks) ? parsedWeeks : 9) : weeksToFilter;


							let suppressExpandOncePatch = {};
							if (shouldUseDb && nextWeeks === 0) {
								suppressExpandOncePatch = { suppressExpandOnce: { ...this.state.suppressExpandOnce, 1: true } };
							}
							const isDefaultNoFilter = shouldUseDb && nextWeeks === 0;
							this.setState(prevState => ({
								...prevState,
								queuedInvoices,
								weeksToFilter1: nextWeeks,
								initialLoad: { ...prevState.initialLoad, 1: false },
								isDefaultDBNoFilter: {
									...prevState.isDefaultDBNoFilter,
									1: prevState.isDefaultDBNoFilter[1] || isDefaultNoFilter
								},
								serverMode: isDefaultNoFilter
									? { ...prevState.serverMode, 1: false }
									: prevState.serverMode,
								...suppressExpandOncePatch
							}), () => {
								if (shouldUseDb && (nextWeeks === 0 || Number.isInteger(nextWeeks))) {
									//setFilter([getInvoiceModuleName(this.props.modelDefId), 'Dashboard', 'weeksToFilter1'], nextWeeks);
								}
							});
						}
						break;

					case 2:
						//unmatchedInvoices = data.unmatchedInvoices;
						//that.setRowId(unmatchedInvoices);
						//distinctRoutedToResourceList = that.getDistinctRoutedToResourceList(unmatchedInvoices);
						//filteredUnmatchedInvoices = that.getFilteredUnmatchedInvoices(unmatchedInvoices, that.state.selectedRoutedToResourceId);
						//this.setState(prevState => ({
						//	...prevState,
						//	unmatchedInvoices,
						//	weeksToFilter2: weeksToFilter,
						//	distinctRoutedToResourceList,
						//	filteredUnmatchedInvoices
						//}));


						const unmatchedInvoicesRows = data.unmatchedInvoices.listOfItems || [];
						unmatchedInvoices = invoiceDocumentId ?
							this.upsertInvoiceRow(this.state.unmatchedInvoices, unmatchedInvoicesRows, invoiceDocumentId)
							: unmatchedInvoicesRows;
						isAllowRoutingSetup = data.unmatchedInvoices.ruleSet?.[0]?.isAllowRoutingSetup || false;
						that.setRowId(unmatchedInvoices);
						unmatchedInvoices.sort(that.sortDiscrepantInvoices);

						// Get new routed resources from unmatched invoices
						const newResources = that.getDistinctRoutedToResourceList(unmatchedInvoices);

						// Existing list from state
						const prevResources = this.state.distinctRoutedToResourceList || [];

						// Use a Set to check for already present IDs
						const existingIds = new Set(prevResources.map(r => r.routedToResourceId));

						// Append only truly new ones
						const uniqueNewResources = newResources.filter(r => !existingIds.has(r.routedToResourceId));

						// Merge old + new
						const distinctRoutedToResourceList = [...prevResources, ...uniqueNewResources];

						// Inject stored routed resource if it's missing
						const selectedId = this.state.selectedRoutedToResourceId;
						const selectedName = this.state.selectedRoutedToResourceName;

						if (
							selectedId !== "-1" &&
							!distinctRoutedToResourceList.some(r => r.routedToResourceId === selectedId)
						) {
							distinctRoutedToResourceList.push({
								routedToResourceId: selectedId,
								routedTo: selectedName
							});
						}
						// Update filtered unmatched invoices
						filteredUnmatchedInvoices = that.getFilteredUnmatchedInvoices(unmatchedInvoices, selectedId);

						{
							const firstWeeksFilter = data.unmatchedInvoices?.weeksFilter;
							const shouldUseDb = usedAuto || this.state.initialLoad[2] === true;
							const rawWeeks = firstWeeksFilter;
							const parsedWeeks = (rawWeeks == null) ? null
								: (typeof rawWeeks === 'number' ? rawWeeks : parseInt(String(rawWeeks), 10));
							const nextWeeks = shouldUseDb ? (Number.isFinite(parsedWeeks) ? parsedWeeks : 9) : weeksToFilter;
							let suppressExpandOncePatch = {};
							if (shouldUseDb && nextWeeks === 0) {
								suppressExpandOncePatch = { suppressExpandOnce: { ...this.state.suppressExpandOnce, 2: true } };
							}
							const isDefaultNoFilter = shouldUseDb && nextWeeks === 0;

							this.setState(prevState => ({
								...prevState,
								unmatchedInvoices,
								isAllowRoutingSetup,
								distinctRoutedToResourceList,
								filteredUnmatchedInvoices,
								weeksToFilter2: invoiceDocumentId === null ? nextWeeks : prevState.weeksToFilter2,
								initialLoad: { ...prevState.initialLoad, 2: false },
								isDefaultDBNoFilter: {
									...prevState.isDefaultDBNoFilter,
									2: prevState.isDefaultDBNoFilter[2] || isDefaultNoFilter
								},
								serverMode: isDefaultNoFilter
									? { ...prevState.serverMode, 2: false }
									: prevState.serverMode,
								...suppressExpandOncePatch
							}), () => {
								if (shouldUseDb && (nextWeeks === 0 || Number.isInteger(nextWeeks))) {
									//setFilter([getInvoiceModuleName(this.props.modelDefId), 'Dashboard', 'weeksToFilter2'], nextWeeks);
								}
							});
						}

						break;

					case 3:

						const pendingApprovalInvoicesRows = data.pendingApprovalInvoices.listOfItems || [];

						pendingApprovalInvoices = invoiceDocumentId
							? this.upsertInvoiceRow(
								this.state.pendingApprovalInvoices,
								pendingApprovalInvoicesRows,
								invoiceDocumentId
							)
							: pendingApprovalInvoicesRows;

						isAllowApprovalRoutingSetup = data.pendingApprovalInvoices.ruleSet?.[0]?.isAllowApprovalRoutingSetup || false;
						that.setRowId(pendingApprovalInvoices);
						{
							const firstWeeksFilter = data.pendingApprovalInvoices?.weeksFilter;
							const shouldUseDb = usedAuto || this.state.initialLoad[3] === true;
							const rawWeeks = firstWeeksFilter;
							const parsedWeeks = (rawWeeks == null) ? null
								: (typeof rawWeeks === 'number' ? rawWeeks : parseInt(String(rawWeeks), 10));
							const nextWeeks = shouldUseDb ? (Number.isFinite(parsedWeeks) ? parsedWeeks : 9) : weeksToFilter;
							let suppressExpandOncePatch = {};
							if (shouldUseDb && nextWeeks === 0) {
								suppressExpandOncePatch = { suppressExpandOnce: { ...this.state.suppressExpandOnce, 3: true } };
							}
							const isDefaultNoFilter = shouldUseDb && nextWeeks === 0;
							this.setState(prevState => ({
								...prevState,
								pendingApprovalInvoices,
								isAllowApprovalRoutingSetup,
								weeksToFilter3: invoiceDocumentId === null ? nextWeeks : prevState.weeksToFilter3,
								initialLoad: { ...prevState.initialLoad, 3: false },
								isDefaultDBNoFilter: {
									...prevState.isDefaultDBNoFilter,
									3: prevState.isDefaultDBNoFilter[3] || isDefaultNoFilter
								},
								serverMode: isDefaultNoFilter
									? { ...prevState.serverMode, 3: false }
									: prevState.serverMode,
								...suppressExpandOncePatch
							}), () => {
								if (shouldUseDb && (nextWeeks === 0 || Number.isInteger(nextWeeks))) {
									//setFilter([getInvoiceModuleName(this.props.modelDefId), 'Dashboard', 'weeksToFilter3'], nextWeeks);
								}
							});
						}
						break;

					case 4:
						{
							const approvedInvoicesRows = data.approvedInvoices.listOfItems || [];
							const weeksFilter4 = data.approvedInvoices.weeksFilter;
							{
								const firstWeeksFilter = weeksFilter4;
								const shouldUseDb = usedAuto || this.state.initialLoad[4] === true;
								const rawWeeks = firstWeeksFilter;
								const parsedWeeks = (rawWeeks == null) ? null
									: (typeof rawWeeks === 'number' ? rawWeeks : parseInt(String(rawWeeks), 10));
								const nextWeeks = shouldUseDb ? (Number.isFinite(parsedWeeks) ? parsedWeeks : 9) : weeksToFilter;
								let suppressExpandOncePatch = {};
								if (shouldUseDb && nextWeeks === 0) {
									suppressExpandOncePatch = { suppressExpandOnce: { ...this.state.suppressExpandOnce, 4: true } };
								}
								const isDefaultNoFilter = shouldUseDb && nextWeeks === 0;

								// Fix 1: perform upsertInvoiceRow inside the setState updater so it always
								// merges against the freshest approvedInvoices, never a stale closure snapshot
								// captured at .then() time (which could overwrite a concurrent state update).
								this.setState(prevState => {
									const mergedApproved = invoiceDocumentId
										? this.upsertInvoiceRow(prevState.approvedInvoices, approvedInvoicesRows, invoiceDocumentId)
										: approvedInvoicesRows;
									that.setRowId(mergedApproved);

									return {
										...prevState,
										approvedInvoices: mergedApproved,
										weeksToFilter4: invoiceDocumentId === null ? nextWeeks : prevState.weeksToFilter4,
										initialLoad: { ...prevState.initialLoad, 4: false },
										isDefaultDBNoFilter: {
											...prevState.isDefaultDBNoFilter,
											4: prevState.isDefaultDBNoFilter[4] || isDefaultNoFilter
										},
										serverMode: isDefaultNoFilter
											? { ...prevState.serverMode, 4: false }
											: prevState.serverMode,
											...suppressExpandOncePatch
									};
								}, () => {
									if (shouldUseDb && (nextWeeks === 0 || Number.isInteger(nextWeeks))) {
										//setFilter([getInvoiceModuleName(this.props.modelDefId), 'Dashboard', 'weeksToFilter4'], nextWeeks);
									}

									if (gadgetNumber === 4 && invoiceDocumentId) {
										// Fix 2: clear the row-level spinner INSIDE this setState callback so
										// it only fires after the updated status is committed to state.
										// Previously it ran in the outer .then() block, creating a window where
										// the spinner was gone but the row still showed the old status.
										this.setState(prev => {
											const nextReloading = { ...(prev.rowReloading || {}) };
											delete nextReloading[invoiceDocumentId];
											return {
												rowReloading: nextReloading,
												gadgetLoading: { ...prev.gadgetLoading, [gadgetNo]: false }
											};
										}, () => {
											// Read updated row from fresh state for the repost dialog check
											const updatedRow = (this.state.approvedInvoices || []).find(r => r.invoiceDocumentId === invoiceDocumentId);
											if (
												isAvailableForRescaning &&
												updatedRow &&
												updatedRow.invoiceDocumentStatusId === 170 &&
												applyToInvoiceDocumentId &&
												Number(applyToInvoiceDocumentId) > 0
											) {
												this.setState({
													creditMemoRowForRepost: updatedRow,
													openCreditMemoRepostDialog: true,
													applyToInvoiceDocumentId: applyToInvoiceDocumentId
												});
											}
										});
									}
								});
							}
						}
						break;

					default:
						queuedInvoices = data.queuedInvoices.listOfItems;
						unmatchedInvoices = data.unmatchedInvoices.listOfItems;
						pendingApprovalInvoices = data.pendingApprovalInvoices.listOfItems;
						approvedInvoices = data.approvedInvoices.listOfItems;
						that.setRowId(queuedInvoices);
						queuedInvoices.forEach(row => row.invoiceDocumentFileLocation = row.documentManualUploadFileLocation);
						that.setRowId(unmatchedInvoices);
						that.setRowId(pendingApprovalInvoices);
						that.setRowId(approvedInvoices);
						distinctRoutedToResourceList = that.getDistinctRoutedToResourceList(unmatchedInvoices);
						filteredUnmatchedInvoices = that.getFilteredUnmatchedInvoices(unmatchedInvoices, that.state.selectedRoutedToResourceId);

						that.setState({
							weeksToFilter1: weeksToFilter,
							weeksToFilter2: weeksToFilter,
							weeksToFilter3: weeksToFilter,
							weeksToFilter4: weeksToFilter,
							queuedInvoices,
							unmatchedInvoices,
							filteredUnmatchedInvoices,
							pendingApprovalInvoices,
							approvedInvoices,
							modelDefId,
							distinctRoutedToResourceList
						});
						break;
				}

				// When everything is done, stop loading and show tooltip
				const clearRowReloading = () => {
					if (!invoiceDocumentId) return;
					this.setState(prev => {
						const next = { ...(prev.rowReloading || {}) };
						delete next[invoiceDocumentId];
						return { rowReloading: next };
					});
				};

				if (!invoiceDocumentId) {
					this.setState(prevState => ({
						gadgetLoading: { ...prevState.gadgetLoading, [gadgetNo]: false },
						...(isNewUi() ? { gadgetFailed: { ...prevState.gadgetFailed, [gadgetNo]: false } } : {}), // new UI: the queue card says whether its list loaded
						//showSearchTooltip: prevState.switchToFullScreen && prevState.showGadget === gadgetNo
						//	? true
						//	: false
					}), () => {
						let searchText = search;
						const gridRef = this.getGridRef(gadgetNo)?.current;
						this.setState(prev => ({
							filterText: {
								...prev.filterText,
								[gadgetNo]: searchText
							}
						}));

						if (gridRef) {

							if (resetGadgetToFirstPage && typeof gridRef.setPage === 'function') {
								gridRef.setPage(0);
							}
							if (typeof gridRef.setQuickFilterValues === 'function') {

								gridRef.setQuickFilterValues([searchText]);
							}
						}
						else {
							console.warn(`GridRef not available for gadget ${gadgetNo} yet.`);
						}
					});
				} else if (gadgetNumber !== 4) {
					// Gadget 4 row-level refreshes manage their own clearRowReloading inside
					// the setState callback to guarantee the spinner clears only after the new
					// row data is committed to state. All other gadgets clear here as before.
					clearRowReloading();
				}
			})
			.catch((error) => {
				if (isNewUi() && !invoiceDocumentId) this.setState(prev => ({ gadgetFailed: { ...prev.gadgetFailed, [gadgetNo]: true } })); // new UI: "Couldn't load" on the queue card
				checkForUnAuthorizedException(that, error);
				// Fix 3: clean up sequence tracking on error so a retry isn't blocked
				if (gadgetNumber === 4 && invoiceDocumentId && thisSeq !== null
					&& this._rowFetchSequence[invoiceDocumentId] === thisSeq) {
					delete this._rowFetchSequence[invoiceDocumentId];
				}
				if (!invoiceDocumentId) {
					this.setState(prevState => ({
						gadgetLoading: { ...prevState.gadgetLoading, [gadgetNo]: false }
					}));
				} else {
					this.setState(prev => {
						const next = { ...(prev.rowReloading || {}) };
						delete next[invoiceDocumentId];
						return { rowReloading: next };
					});
				}
				toast.error(`An error occurred while fetching the '${gridTitle}' records`);
				console.error(`There was an error fetching the '${gridTitle}' records!`, error);
			});
	}
	setRowId(data) {
		var rowId = 1;
		data.map(row => row.rowId = rowId++);
	}
	fetchAllDashboardData() {
		const weeks1 = this.state.weeksToFilter1;
		const weeks2 = this.state.weeksToFilter2;
		const weeks3 = this.state.weeksToFilter3;
		const weeks4 = this.state.weeksToFilter4;

		const w1 = this.state.userHasSetWeeks[1] ? weeks1 : -1;
		const w2 = this.state.userHasSetWeeks[2] ? weeks2 : -1;
		const w3 = this.state.userHasSetWeeks[3] ? weeks3 : -1;
		const w4 = this.state.userHasSetWeeks[4] ? weeks4 : -1;

		this.fetchDashboard(1, w1, this.getFilterText(1));
		this.fetchDashboard(2, w2, this.getFilterText(2));
		this.fetchDashboard(3, w3, this.getFilterText(3));
		this.fetchDashboard(4, w4, this.getFilterText(4));
	}

	getQuickFilterDebounceMs(gadgetNumber, clientDebounceMs = 1200) {
		const weeks = Number(this.state[`weeksToFilter${gadgetNumber}`] ?? 0);
		const isDefaultDbNoFilter = !!this.state.isDefaultDBNoFilter?.[gadgetNumber];

		// Server-side search only when weeks=0 + serverMode=true + NOT DB-default no-filter
		const isServerSideSearch =
			weeks === 0 && !!this.state.serverMode?.[gadgetNumber] && !isDefaultDbNoFilter;

		return isServerSideSearch ? null : clientDebounceMs;
	}


	async componentDidMount() {
		try {


			await this.initializeFiltersFromStorage();
			//await this.initializeFiltersFromStorage().then(() => {

			//	const fullscreenstate = this.getFullScreenState(0);
			//	const serverMode = fullscreenstate.serverMode;
			//	this.setState((prevState) => ({
			//		...prevState, serverMode: serverMode
			//	}));
			//});

			this.fetchRepostRuleEditable(this.companyCode, this.userRoleId, this.props.modelDefId);

			await Promise.all([
				this.fetchAllDashboardData()
			]);

		} catch (error) {
			console.error('Error loading dashboard:', error);
		}
	}

	downloadFile = (invoiceDocumentId, invoiceDocumentFileLocation, fromQueue = 0) => {
		if (!invoiceDocumentFileLocation) {
			toast.error('File location not found.');
			return;
		}

		this.setState(prev => ({
			downloadingInvoices: {
				...prev.downloadingInvoices,
				[invoiceDocumentId]: true
			}
		}));

		const clearDownloadState = () => {
			this.setState(prev => {
				const next = { ...prev.downloadingInvoices };
				delete next[invoiceDocumentId];
				return { downloadingInvoices: next };
			});
		};
		const encodedFileLocation = encodeURIComponent(invoiceDocumentFileLocation);
		const fromQueueQuery = fromQueue === 1 ? '&fromQueue=1' : '';

		httpGet(
			`/api/InvoiceDocument/documenturl/${this.props.modelDefId}?documentFileLocation=${encodedFileLocation}${fromQueueQuery}`
		)
			.then((response) => {
				const url = response.data?.documentUrl;

				if (!url) {
					throw new Error('FILE_NOT_FOUND');
				}

				window.open(url, '_blank', 'noopener,noreferrer');

				clearDownloadState();
			})
			.catch((error) => {

				const isNotFoundError =
					error?.response?.status === 422 ||
					error?.message === 'FILE_NOT_FOUND';

				if (isNotFoundError) {
					toast.error('File not found.');
				} else {
					toast.error('Failed to download the file.');
				}

				clearDownloadState();
			});
	};


	toggleFavoriteStatus = async (row) => {

		const payload = {
			modelDefId: row.modelDefId,
			invoiceDocumentId: row.invoiceDocumentId,
			isFavorite: row.isFavorite === "Y" ? "N" : "Y"
		};

		const originalFlag = row.isFavorite;
		row.isFavorite = originalFlag === "Y" ? "N" : "Y";

		this.setState(prev => ({
			filteredUnmatchedInvoices: [...prev.filteredUnmatchedInvoices]
		}));

		try {
			const res = await httpPost('/api/invoicedocument/updateinvoicefavouritestatus', payload);
			if (!res.data.success) {

				row.isFavorite = originalFlag;
				this.setState(prev => ({
					filteredUnmatchedInvoices: [...prev.filteredUnmatchedInvoices]
				}));
				toast.error("Failed to update favorite");
			}
		} catch (error) {
			row.isFavorite = originalFlag;
			this.setState(prev => ({
				filteredUnmatchedInvoices: [...prev.filteredUnmatchedInvoices]
			}));
			toast.error("Could not update favorite");
		}

	};

	sortDiscrepantInvoices = (a, b) => {
		const aFav = a.isFavorite === "Y" ? 1 : 0;
		const bFav = b.isFavorite === "Y" ? 1 : 0;

		if (bFav - aFav !== 0) return bFav - aFav;

		const aDate = new Date(a.invoiceDocumentScanUpdateDate || 0);
		const bDate = new Date(b.invoiceDocumentScanUpdateDate || 0);

		return bDate - aDate;
	};

	setSortModel(gadgetNo, model) {
		this.setState(prev => ({
			sortModel: {
				...prev.sortModel,
				[gadgetNo]: model
			}
		}));

		setFilter([getInvoiceModuleName(this.props.modelDefId), 'Dashboard', `sortModel${gadgetNo}`], model);
	}

	//#region Components
	getRoutedToResources(selectedResources, invoiceDocumentId) {
		var routedToResources = [];
		selectedResources.map(function (selectedResource, selectedResourceIndex) {
			const invoiceDocumentResourceRoutingHistory = { invoiceDocumentId: invoiceDocumentId, resourceId: selectedResource.resourceId, email: selectedResource.email, comments: selectedResource.comments };
			routedToResources.push(invoiceDocumentResourceRoutingHistory);
		});
		return routedToResources;
	}
	//getRefreshButton(gadgetNumber) {

	//	return <IconButton
	//		variant="contained"
	//		onClick={this.refresh_clickHandler}
	//		size="small"
	//		style={{ float: "right", zIndex: 1, marginTop: 10 }}
	//		data-gadgetnumber={gadgetNumber}
	//	>
	//		<Tooltip key={1} title={'Refresh'}>
	//			<RefreshIcon key={2} />
	//		</Tooltip>
	//	</IconButton>;
	//}

	getRefreshButton = (gadgetNumber) => {
		return (
			<IconButton
				variant="contained"
				onClick={this.refresh_clickHandler}
				size="small"
				style={{ float: "right", zIndex: 1, marginTop: 10 }}
				data-gadgetnumber={gadgetNumber}
			>
				<Tooltip key={1} title={'Refresh'}>
					<RefreshIcon key={2} />
				</Tooltip>
			</IconButton>
		);
	};

	getOpenInFullScreenButton(gadgetNumber) {

		if (this.state.showGadget == 0)
			return <IconButton
				variant="contained"
				onClick={(el) => this.showFullScreen(gadgetNumber)}
				size="small"
				style={{ float: "right", zIndex: 1, marginTop: 10 }}
				data-gadgetnumber={gadgetNumber}>
				<Tooltip key={gadgetNumber + 4} title={'Full screen View'}>
					<FullscreenIcon key={gadgetNumber + 4} />
				</Tooltip>
			</IconButton>;

		else
			return <IconButton
				variant="contained"
				onClick={(el) => this.showFullScreen(gadgetNumber)}
				size="small"
				style={{ float: "right", zIndex: 1, marginTop: 10 }}
				data-gadgetnumber={gadgetNumber}>
				<Tooltip key={gadgetNumber + 5} title={'Gadget View'}>
					<FullscreenExitIcon key={gadgetNumber + 5} />
				</Tooltip>
			</IconButton>;
	}
	getUploadButton(gadgetNumber) {
		return <IconButton
			variant="contained"
			onClick={this.fileUpload_clickHandler}
			size="small"
			style={{ float: "right", zIndex: 1, marginTop: 10 }}
			data-gadgetnumber={gadgetNumber}>
			<Tooltip key={1} title={'Click to upload file(s) OR drag & drop file(s) on the grid'}>
				<CloudUploadIcon key={2} />
			</Tooltip>
		</IconButton>;
	}
	getScanButton(gadgetNumber) {
		return <IconButton
			variant="contained"
			onClick={this.scanAll_clickHandler}
			size="small"
			style={{ float: "right", zIndex: 1, marginTop: 10 }}
			data-gadgetnumber={gadgetNumber}>
			<Tooltip key={1} title={'Scan Seleted'}>
				<ScannerIcon key={2} />
			</Tooltip>
		</IconButton>;
	}
	getDeleteButton(gadgetNumber) {
		if (!this.state.deletePermission) return null;
		return <IconButton
			variant="contained"
			onClick={this.openDeleteDialog}
			size="small"
			style={{ float: "right", zIndex: 1, marginTop: 10 }}
			data-gadgetnumber={gadgetNumber}>
			<Tooltip key={1} title={'Delete Selected'}>
				<DeleteOutlineIcon key={2} />
			</Tooltip>
		</IconButton>;
	}
	//showFullScreen(gadgetNo) {
	//	//if (this.state.showGadget !== gadgetNo)
	//	//	this.setState({ showGadget: gadgetNo, pageSize: 25, rowsPerPage: [25, 40, 50, 100], isExpanded: true });
	//	//else
	//	//	this.setState({ showGadget: 0, pageSize: 5, rowsPerPage: [5, 10, 20, 30, 40, 50], isExpanded: false });
	//	this.setState(prevState => {
	//		let obj = this.getFullScreenState(gadgetNo);
	//		return {
	//			...obj,
	//			filterText: { ...prevState.filterText },
	//		}
	//	}, () => {
	//		if (!this.state.switchToFullScreen) {
	//			this.fetchDashboard(gadgetNo, 9, '', true);
	//			//this.getGridRef(gadgetNo).current.setQuickFilterValues([]);
	//		}
	//		else {
	//			this.fetchDashboard(gadgetNo, 0, this.state.filterText[gadgetNo] || '')
	//		}
	//	});
	//}


	showFullScreen(gadgetNo) {
		this.setState(prevState => {
			const isFullScreen = prevState.showGadget !== gadgetNo;

			const fullScreenState = this.getFullScreenState(gadgetNo);

			return {
				...fullScreenState,
				filterText: { ...prevState.filterText },
				showSearchTooltip: false
			};
		}, () => {
			if (!this.state.switchToFullScreen) {

				const currentText = this.getFilterText(gadgetNo);
				const isDefaultDbNoFilter = this.state.isDefaultDBNoFilter[gadgetNo];

				if (this.state[`weeksToFilter${gadgetNo}`] === 0 && !currentText && !isDefaultDbNoFilter) {

					setFilter([getInvoiceModuleName(this.props.modelDefId), 'Dashboard', `weeksToFilter${gadgetNo}`], DEFAULT_WEEKS);
					setFilter([getInvoiceModuleName(this.props.modelDefId), 'Dashboard', `searchText${gadgetNo}`], '');
					this.fetchDashboard(gadgetNo, DEFAULT_WEEKS, '', false);
					this.state.initialLoad[gadgetNo] = false;
				}


				[1, 2, 3, 4].forEach(gadget => {

					const gridRef = this.getGridRef(gadget)?.current;


					if (gridRef && typeof gridRef.setQuickFilterValues === 'function') {

						if (gadgetNo === gadget) {
							if (currentText) {
								gridRef.setQuickFilterValues([this.getFilterText(gadget)]);
							}
						} else {
							gridRef.setQuickFilterValues([this.getFilterText(gadget)]);
						}
					}

				});
			}
			else {
				const gridRef = this.getGridRef(gadgetNo)?.current;
				if (gridRef && typeof gridRef.setQuickFilterValues === 'function') {
					gridRef.setQuickFilterValues([this.getFilterText(gadgetNo)]);
				}
			}
		});
	}


	getFullScreenState(gadgetNo) {
		const prevState = this.state;
		const isFullScreen = prevState.showGadget !== gadgetNo;

		const calcServerMode = (g) => {
			// If DB default is No Filter (0) → this gadget is ALWAYS client-mode
			if (prevState.isDefaultDBNoFilter[g]) {
				return false;
			}

			return (
				(isFullScreen && prevState.showGadget === g) ||
				(!isFullScreen &&
					prevState.filterText[g] !== '' &&
					prevState[`weeksToFilter${g}`] === 0)
			);
		};

		return {
			showGadget: isFullScreen ? gadgetNo : 0,
			pageSize: isFullScreen ? 25 : 5,
			rowsPerPage: isFullScreen ? [25, 40, 50, 100] : [5, 10, 20, 30, 40, 50],
			isExpanded: isFullScreen,
			switchToFullScreen: isFullScreen,
			serverMode: {
				1: calcServerMode(1),
				2: calcServerMode(2),
				3: calcServerMode(3),
				4: calcServerMode(4),
			}
		};
	}


	//getFullScreenState(gadgetNo) {
	//	const prevState = this.state;
	//	const isFullScreen = prevState.showGadget !== gadgetNo;
	//	return {
	//		showGadget: isFullScreen ? gadgetNo : 0,
	//		pageSize: isFullScreen ? 25 : 5,
	//		rowsPerPage: isFullScreen ? [25, 40, 50, 100] : [5, 10, 20, 30, 40, 50],
	//		isExpanded: isFullScreen,
	//		switchToFullScreen: isFullScreen,
	//		serverMode: {
	//			1: (isFullScreen && this.state.showGadget == 1) || (!isFullScreen && this.state.filterText[1] !== '' && this.state[`weeksToFilter${1}`] === 0),
	//			2: (isFullScreen && this.state.showGadget == 2) || (!isFullScreen && this.state.filterText[2] !== '' && this.state[`weeksToFilter${2}`] === 0),
	//			3: (isFullScreen && this.state.showGadget == 3) || (!isFullScreen && this.state.filterText[3] !== '' && this.state[`weeksToFilter${3}`] === 0),
	//			4: (isFullScreen && this.state.showGadget == 4) || (!isFullScreen && this.state.filterText[4] !== '' && this.state[`weeksToFilter${4}`] === 0),
	//		}
	//	};

	//}

	getRoutedToFilterDropDown() {

		const isRoutedToAllInvoices = this.state.selectedRoutedToResourceId === "-1";

		return <Select
			variant="standard"
			name="routed-to-filter"
			value={this.state.selectedRoutedToResourceId}
			onChange={this.routedToResourceList_changeHandler}
			sx={{
				float: "right",
				zIndex: 1,
				mt: 1.25,
				width: 100,
				backgroundColor: !isRoutedToAllInvoices ? "rgba(0, 140, 205, 0.25)" : 'inherit',
				"&.Mui-focused": {
					backgroundColor: !isRoutedToAllInvoices ? "rgba(0, 140, 205, 0.25)" : 'inherit',
				},
			}}
		>
			<MenuItem value="-1">All Invoices</MenuItem>
			{
				this.state.distinctRoutedToResourceList.map(function (routedToResource, index) {
					return <MenuItem key={index} value={routedToResource.routedToResourceId}>{routedToResource.routedTo}</MenuItem>
				})
			}
		</Select>;
	}
	getWeeksToFilterDropDown(gadgetNumber, searchFilter) {

		const selectedValue = Number(this.state["weeksToFilter" + gadgetNumber] ?? 0);

		return (
			<Select
				variant="standard"
				name={`weeks-to-filter-${gadgetNumber}`}
				sx={{
					float: "right",
					zIndex: 1,
					mt: 1.25,
					mr: 1.25,
					width: 100,
					backgroundColor: "rgba(0, 140, 205, 0.12)",
					"&.Mui-focused": {
						backgroundColor: "rgba(0, 140, 205, 0.12)",
					},
				}}
				value={selectedValue}
				onChange={(e) => {
					this.weeksToFilter_changeHandler({
						e: { ...e },
						target: { ...e.target },
						currentTarget: {
							dataset: {
								gadgetnumber: gadgetNumber,
								searchFilter: searchFilter,
							},
						},
					});
				}}
			>
				<MenuItem value={0}>No Filter</MenuItem>
				<MenuItem value={1}>1 Week</MenuItem>
				<MenuItem value={2}>2 Weeks</MenuItem>
				<MenuItem value={4}>4 Weeks (1 Month)</MenuItem>
				<MenuItem value={9}>9 Weeks (2 Months)</MenuItem>
				<MenuItem value={26}>26 Weeks (6 Months)</MenuItem>
				<MenuItem value={52}>52 Weeks (1 Year)</MenuItem>
			</Select>
		);
	}

	displayActions(rowData) {
		return rowData.approvalLinkText.length > 0 ? <Link data-rowid={rowData.rowId} data-source="pendingApprovalInvoices" data-mode="Approval" href="#" onClick={this.invoiceDocument_clickHandler}>{rowData.approvalLinkText ? "Approval" : ""}</Link> : <></>;

	}
	displayVendorName(rowData) {
		return stringIsNullOrEmpty(rowData.vendorName) ? rowData.vendorCode : rowData.vendorName;
	}
	getRoutedToInfoColumn(rowData) {
		var returnValue = <div></div>;
		if (rowData.routedTo === "Not Routed") {
			if (rowData.suggestionFlag === "H") {
				returnValue = <Link href="#"><Tooltip title="route to IO/PO resources" ><EmojiObjectsIcon style={{ color: green[500], fontSize: 20 }} data-invoicedocumentid={rowData.invoiceDocumentId} onClick={this.suggestionFlag_clickHandler} /></Tooltip></Link>;
			}
			else if (rowData.suggestionFlag === "L") {
				returnValue = <Link href="#"><Tooltip title="route to any resources"><EmojiObjectsOutlinedIcon style={{ color: orange[500], fontSize: 20 }} data-invoicedocumentid={rowData.invoiceDocumentId} onClick={this.suggestionFlag_clickHandler} /></Tooltip></Link>;
			}
		}
		else {
			if (rowData.suggestionFlag === "N") {
				if (rowData.createId === "system") {
					returnValue = <Tooltip title="routed by system" ><DirectionsIcon color="primary" sx={{ fontSize: 20 }} /></Tooltip>;
				}
				else {
					if (rowData.comments && rowData.comments.trim()) {
						returnValue = <Tooltip title={rowData.comments} ><MessageIcon color="primary" sx={{ fontSize: 20 }} /></Tooltip>;
					}
					else {
						returnValue = <MessageIcon color="disabled" sx={{ fontSize: 20 }} />;
					}

				}
			}
		}
		return returnValue;
	}
	getDistinctRoutedToResourceList(unmatchedInvoices) {
		var distinctRoutedtoResources = [];
		unmatchedInvoices.map(function (unmatchedInvoice, index) {
			if (unmatchedInvoice.routedToCsv && unmatchedInvoice.routedToCsv.split('|$|').length > 1) {
				var routedTo = unmatchedInvoice.routedToCsv.split('|$|');
				for (var i = 0; i < routedTo.length; i++) {
					if (routedTo[i]) {
						var resName = defaultStringIfNullOrEmpty(routedTo[i].split('|')[1], "Not Routed");
						var resId = defaultStringIfNullOrEmpty(routedTo[i].split('|')[0], "Not Routed")
						var routedToResource = {
							routedToResourceId: resId,
							routedTo: resName
						};
						if (!distinctRoutedtoResources.some(r => r.routedToResourceId === resId)) {
							distinctRoutedtoResources.push(routedToResource);
						};
					}
				}
			}
			else {
				var routedToResource = {
					routedToResourceId: defaultStringIfNullOrEmpty(unmatchedInvoice.routedToResourceId, "Not Routed"),
					routedTo: unmatchedInvoice.routedTo
				};
				if (!distinctRoutedtoResources.some(r => r.routedToResourceId === defaultStringIfNullOrEmpty(unmatchedInvoice.routedToResourceId, "Not Routed"))) {
					distinctRoutedtoResources.push(routedToResource);
				};
			}
		});
		return distinctRoutedtoResources.sort((a, b) => (a.routedToResourceId > b.routedToResourceId ? 0 : -1));
	}
	getFilteredUnmatchedInvoices(unmatchedInvoices, routedToResourceId) {
		var filteredUnmatchedInvoices = [];
		filteredUnmatchedInvoices = routedToResourceId === "-1" ? unmatchedInvoices : unmatchedInvoices.filter(unmatchedInvoice => defaultStringIfNullOrEmpty(unmatchedInvoice.routedToResourceId, "Not Routed").includes(routedToResourceId));
		return filteredUnmatchedInvoices;
	}
	displayUploadStatus(uploadStatus) {
		switch (uploadStatus) {
			case 1:
				return <div>Not Processed</div>;
			case 2:
				return <div>Scan in Progress</div>;
			default:
				return <div>Unknown</div>;
		}
	}

	//#endregion
	//#region Events

	weeksToFilter_changeHandler(event) {
		const gadgetNumber = parseInt(event.currentTarget.dataset.gadgetnumber, 10);
		this.setState(prev => ({
			userHasSetWeeks: {
				...prev.userHasSetWeeks,
				[gadgetNumber]: true
			}
		}));

		const weeksToFilter = parseInt(event.target.value, 10);
		const prevWeeks = this.state[`weeksToFilter${gadgetNumber}`];
		const isNoFilter = weeksToFilter === 0;
		const moduleKey = getInvoiceModuleName(this.props.modelDefId);
		const isDefaultDbNoFilter = this.state.isDefaultDBNoFilter[gadgetNumber];

		if (isNoFilter && !isDefaultDbNoFilter && !this.state.switchToFullScreen && this.state.showGadget !== gadgetNumber) {
			this.showFullScreen(gadgetNumber);
		}

		const rawText = this.getFilterText(gadgetNumber) || '';
		const trimmedText = rawText.trim();

		// --- CASE 1: Non-zero weeks (normal filters like 1, 2, 9) ---
		if (!isNoFilter || (isNoFilter && isDefaultDbNoFilter)) {
			// Persist weeks + current text like before
			setFilter([moduleKey, 'Dashboard', `weeksToFilter${gadgetNumber}`], weeksToFilter);
			setFilter([moduleKey, 'Dashboard', `searchText${gadgetNumber}`], rawText);

			// Always client mode for non-zero weeks
			const searchFilter = rawText;

			this.setState(prev => ({
				[`weeksToFilter${gadgetNumber}`]: weeksToFilter,
				serverMode: {
					...prev.serverMode,
					[gadgetNumber]: false,
				}
			}), () => {
				this.fetchDashboard(gadgetNumber, weeksToFilter, searchFilter);
			});

			return;
		} else {

			// --- CASE 2: No Filter (0) ---

			// Are we switching from some other filter into NoFilter?
			const isSwitchingFromOtherFilter = prevWeeks !== 0;

			if (isSwitchingFromOtherFilter && trimmedText) {
				// 2a. There is already search text → immediately do a server call with weeks=0
				//     and persist this (0 + text) combo.
				setFilter([moduleKey, 'Dashboard', `weeksToFilter${gadgetNumber}`], 0);
				setFilter([moduleKey, 'Dashboard', `searchText${gadgetNumber}`], trimmedText);

				this.setState(prev => ({
					[`weeksToFilter${gadgetNumber}`]: 0,
					serverMode: {
						...prev.serverMode,
						[gadgetNumber]: true,
					},
				}), () => {
					this.fetchDashboard(gadgetNumber, 0, trimmedText, false);
				});

				return;
			}

			// 2b. No text present (or we were already in 0) → no server call.
			//     Stay in client mode, just update local weeks state and re-apply quick filter.
			const suppressed = !!(this.state.suppressExpandOnce && this.state.suppressExpandOnce[gadgetNumber]);

			this.setState(prev => ({
				...prev,
				[`weeksToFilter${gadgetNumber}`]: 0,
				serverMode: {
					...prev.serverMode,
					[gadgetNumber]: true,
				},
				suppressExpandOnce: suppressed
					? { ...prev.suppressExpandOnce, [gadgetNumber]: false }
					: prev.suppressExpandOnce
			}));

		}


	}



	//weeksToFilter_changeHandler(event) {
	//	const gadgetNumber = parseInt(event.currentTarget.dataset.gadgetnumber, 10);
	//	this.setState(prev => ({
	//		userHasSetWeeks: {
	//			...prev.userHasSetWeeks,
	//			[gadgetNumber]: true
	//		}
	//	}));

	//	const weeksToFilter = parseInt(event.target.value, 10);
	//	const prevWeeks = this.state[`weeksToFilter${gadgetNumber}`];
	//	const isNoFilter = weeksToFilter === 0;
	//	const moduleKey = getInvoiceModuleName(this.props.modelDefId);

	//	if (isNoFilter && !this.state.switchToFullScreen && this.state.showGadget !== gadgetNumber) {
	//		this.showFullScreen(gadgetNumber);
	//	}

	//	const rawText = this.getFilterText(gadgetNumber) || '';
	//	const trimmedText = rawText.trim();

	//	// --- CASE 1: Non-zero weeks (normal filters like 1, 2, 9) ---
	//	if (!isNoFilter) {
	//		// Persist weeks + current text like before
	//		setFilter([moduleKey, 'Dashboard', `weeksToFilter${gadgetNumber}`], weeksToFilter);
	//		setFilter([moduleKey, 'Dashboard', `searchText${gadgetNumber}`], rawText);

	//		// Always client mode for non-zero weeks
	//		const searchFilter = rawText;

	//		this.setState(prev => ({
	//			[`weeksToFilter${gadgetNumber}`]: weeksToFilter,
	//			serverMode: {
	//				...prev.serverMode,
	//				[gadgetNumber]: false,
	//			}
	//		}), () => {
	//			this.fetchDashboard(gadgetNumber, weeksToFilter, searchFilter);
	//		});

	//		return;
	//	}

	//	// --- CASE 2: No Filter (0) ---

	//	// Are we switching from some other filter into NoFilter?
	//	const isSwitchingFromOtherFilter = prevWeeks !== 0;

	//	if (isSwitchingFromOtherFilter && trimmedText) {
	//		// 2a. There is already search text → immediately do a server call with weeks=0
	//		//     and persist this (0 + text) combo.
	//		setFilter([moduleKey, 'Dashboard', `weeksToFilter${gadgetNumber}`], 0);
	//		setFilter([moduleKey, 'Dashboard', `searchText${gadgetNumber}`], trimmedText);

	//		this.setState(prev => ({
	//			[`weeksToFilter${gadgetNumber}`]: 0,
	//			serverMode: {
	//				...prev.serverMode,
	//				[gadgetNumber]: true,
	//			},
	//		}), () => {
	//			this.fetchDashboard(gadgetNumber, 0, trimmedText, false);
	//		});

	//		return;
	//	}

	//	// 2b. No text present (or we were already in 0) → no server call.
	//	//     Stay in client mode, just update local weeks state and re-apply quick filter.
	//	const suppressed = !!(this.state.suppressExpandOnce && this.state.suppressExpandOnce[gadgetNumber]);

	//	this.setState(prev => ({
	//		...prev,
	//		[`weeksToFilter${gadgetNumber}`]: 0,
	//		serverMode: {
	//			...prev.serverMode,
	//			[gadgetNumber]: true,
	//		},
	//		suppressExpandOnce: suppressed
	//			? { ...prev.suppressExpandOnce, [gadgetNumber]: false }
	//			: prev.suppressExpandOnce
	//	}) );
	//}




	routedToResourceList_changeHandler(event) {
		//var gadgetNumber = 2;

		//setFilter(getDashboardModuleName(this.props.modelDefId), "clientSide", `selectedRoutedToResourceId${gadgetNumber}`, event.target.value);

		//var filteredUnmatchedInvoices = this.getFilteredUnmatchedInvoices(this.state.unmatchedInvoices, event.target.value);
		//this.setState({ selectedRoutedToResourceId: event.target.value, filteredUnmatchedInvoices: filteredUnmatchedInvoices });

		const gadgetNumber = 2;
		const selectedId = event.target.value;

		const selectedLabel = this.state.distinctRoutedToResourceList.find(
			(r) => r.routedToResourceId === selectedId
		)?.routedTo;

		setFilter([getInvoiceModuleName(this.props.modelDefId), 'Dashboard', `selectedRoutedToResourceId${gadgetNumber}`],
			{
				routedToResourceId: selectedId,
				routedTo: selectedLabel
			}
		);

		const filteredUnmatchedInvoices = this.getFilteredUnmatchedInvoices(this.state.unmatchedInvoices, selectedId);
		this.setState({
			selectedRoutedToResourceId: selectedId,
			selectedRoutedToResourceName: selectedLabel,
			filteredUnmatchedInvoices
		});
	}
	bulkRouteToEmployee_clickHandler(event) {
		if (this.selectedRows.length > 0) {
			var isProduction = this.props.modelDefId === 2;
			this.setState({ openPOHeaderResourceDialog: !isProduction, openLevel2ResourceDialog: isProduction, source: '' });
		}
	}

	bulkApprovalRouting_clickHandler(event) {
		if (this.selectedRows.length > 0) {
			var isProduction = this.props.modelDefId === 2;
			this.setState({
				openPOHeaderResourceDialog: !isProduction, openLevel2ResourceDialog: isProduction, userRoleName: this.state.userRoleName, source: 'approvalRouting'
			});
		}
	}
	overrideRouting_clickHandler(event) {
		event.preventDefault();
		this.showFullScreen(3);
		this.setState({ isExpanded: true });
	}


	poHeaderResourceDialog_closeHandler(event, poHeaderResources) {
		if (poHeaderResources.length > 0) {
			const source = this.state.source;
			let routedToResources;

			if (source === 'approvalRouting') {
				routedToResources = this.selectedRows.flatMap(selectedRow =>
					poHeaderResources.map(resource => ({
						companyCode: selectedRow.companyCode,
						invoiceDocumentId: selectedRow.invoiceDocumentId,
						comments: resource.comments,
						resourceId: resource.resourceId,
						email: resource.email,
						createBy: "",
						createdDate: new Date().toISOString(),
					}))
				);
			} else {
				routedToResources = this.selectedRows.length > 0
					? this.selectedRows.flatMap(selectedRow => this.getRoutedToResources(poHeaderResources, selectedRow.invoiceDocumentId))
					: this.getRoutedToResources(poHeaderResources, this.state.invoiceDocumentId);
			}

			this.props.inProgress(true);

			const apiEndpoint = source === 'approvalRouting'
				? "/api/invoicedocument/invoiceDocumentApprovalRoutingHistory/"
				: "/api/invoicedocument/routetoemployee/";

			httpPost(apiEndpoint, routedToResources)
				.then((response) => {
					this.props.inProgress(false);
					const updatedInvoiceDocumentId = this.selectedRows.length === 1
						? this.selectedRows[0].invoiceDocumentId : null;

					this.setState({
						highlightedInvoiceDocumentId: updatedInvoiceDocumentId
					});

					this.selectedRows = [];
					if (source === 'approvalRouting') {
						let quickFilter = this.getFilterText(3);
						this.fetchDashboard(3, this.state["weeksToFilter" + 3], quickFilter, false, updatedInvoiceDocumentId);
						this.invoicePendingApprovalGridRef.current.setRowSelectionModel([]);
					}
					else {
						let quickFilter = this.getFilterText(2);
						this.fetchDashboard(2, this.state["weeksToFilter" + 2], quickFilter, false, updatedInvoiceDocumentId);
						this.invoiceUnmatchedGridRef.current.setRowSelectionModel([]);
					}

					const successMessage = source === 'approvalRouting'
						? 'Approval Routing Successful'
						: 'Routed to Employee Successfully';

					toast.success(successMessage);
				})
				.catch((error) => {
					this.props.inProgress(false);

					const errorMessage = source === 'approvalRouting'
						? 'Approval Routing Failed'
						: 'Route to Employee Failed';

					toast.error(errorMessage);
				});
		}

		this.setState({ openPOHeaderResourceDialog: false, invoiceDocumentId: null });
	}

	level2ResourceDialog_closeHandler(event, level2Resources) {
		if (level2Resources.length > 0) {
			const source = this.state.source;
			let routedToResources;

			if (source === 'approvalRouting') {
				routedToResources = this.selectedRows.flatMap(selectedRow =>
					level2Resources.map(resource => ({
						companyCode: selectedRow.companyCode,
						invoiceDocumentId: selectedRow.invoiceDocumentId,
						comments: resource.comments,
						resourceId: resource.resourceId,
						email: resource.email,
						routingDate: new Date().toISOString(),
						createBy: "",
						createdDate: new Date().toISOString(),
					}))
				);
			} else {
				routedToResources = this.selectedRows.length > 0
					? this.selectedRows.flatMap(selectedRow => this.getRoutedToResources(level2Resources, selectedRow.invoiceDocumentId))
					: this.getRoutedToResources(level2Resources, this.state.invoiceDocumentId);
			}

			this.props.inProgress(true);

			const apiEndpoint = source === 'approvalRouting'
				? "/api/invoicedocument/invoiceDocumentApprovalRoutingHistory/"
				: "/api/invoicedocument/routetoemployee/";

			httpPost(apiEndpoint, routedToResources)
				.then((response) => {
					this.props.inProgress(false);
					this.selectedRows = [];
					if (source === 'approvalRouting') {
						const userSet = this.state.userHasSetWeeks[3];
						const weeksToUse = userSet ? this.state["weeksToFilter" + 3] : -1;
						this.fetchDashboard(3, weeksToUse, this.getFilterText(3));
						this.invoicePendingApprovalGridRef.current.setRowSelectionModel([]);
					}
					else {
						const userSet = this.state.userHasSetWeeks[2];
						const weeksToUse = userSet ? this.state["weeksToFilter" + 2] : -1;
						this.fetchDashboard(2, weeksToUse, this.getFilterText(2));
						this.invoiceUnmatchedGridRef.current.setRowSelectionModel([]);
					}

					const successMessage = source === 'approvalRouting'
						? 'Approval Routing Successful'
						: 'Routed to Employee Successfully';

					toast.success(successMessage);
				})
				.catch((error) => {
					this.props.inProgress(false);

					const errorMessage = source === 'approvalRouting'
						? 'Approval Routing Failed'
						: 'Route to Employee Failed';

					toast.error(errorMessage);
				});
		}

		this.setState({ openLevel2ResourceDialog: false, invoiceDocumentId: null });
	}
	refresh_clickHandler(event) {
		var gadgetNumber = parseInt(event.currentTarget.dataset.gadgetnumber);
		var isServerMode = this.state.serverMode[gadgetNumber];
		const userSet = this.state.userHasSetWeeks[gadgetNumber];
		const weeksToUse = userSet ? this.state["weeksToFilter" + gadgetNumber] : -1;

		this.fetchDashboard(gadgetNumber, weeksToUse, this.getFilterText(gadgetNumber));
	}

	bulkDeleteUnmatchedInvoices_clickHandler(event) {
		event?.preventDefault?.();

		const gadgetNo = parseInt(event?.currentTarget?.dataset?.gadgetnumber, 10) || 2;
		const selectedRows = this.selectedRows || [];
		const requestItems = Array.from(new Map(
			selectedRows
				.filter(row => row?.invoiceDocumentId)
				.map(row => [row.invoiceDocumentId, {
					invoiceDocumentId: row.invoiceDocumentId,
					invoiceDocumentTimestamp: Number(row.invoiceDocumentTimestamp || 0)
				}])
		).values());
		const invoiceDocumentIds = requestItems.map(item => item.invoiceDocumentId);

		if (invoiceDocumentIds.length === 0) {
			toast.error('No invoice(s) selected for delete');
			return;
		}

		this.setState(prevState => ({
			gadgetLoading: { ...prevState.gadgetLoading, [gadgetNo]: true }
		}));

		httpPost('/api/invoicedocument/bulkdelete', requestItems)
			.then((response) => {
				const deleted = response?.data?.deleted || [];
				const failed = response?.data?.failed || [];
				const concurrencyFailures = failed.filter(x => x?.errorCode === -3 || (x?.errorMessage || '').toLowerCase().includes('updated by another user'));
				const deletedByOthers = failed.filter(x => x?.errorCode === -2 || (x?.errorMessage || '').toLowerCase().includes('deleted by another user'));
				const concurrencyFailureMessage = concurrencyFailures.find(x => x?.errorMessage)?.errorMessage;
				const deletedByOthersMessage = deletedByOthers.find(x => x?.errorMessage)?.errorMessage;

				this.selectedRows = [];

				if (this.invoiceUnmatchedGridRef.current && typeof this.invoiceUnmatchedGridRef.current.setRowSelectionModel === 'function') {
					this.invoiceUnmatchedGridRef.current.setRowSelectionModel([]);
				}

				if (failed.length === 0 && deleted.length > 0) {
					toast.success(invoiceDocumentIds.length > 1
						? 'Invoices deleted successfully'
						: 'Invoice deleted successfully');
				} else if (concurrencyFailures.length > 0) {
					toast.warning(concurrencyFailureMessage || 'Delete failed');
				} else if (deletedByOthers.length > 0) {
					toast.info(deletedByOthersMessage || 'Delete failed');
				} else if (failed.length > 0) {
					toast.error(failed[0]?.errorMessage || 'Delete failed');
				}

				const userSet = this.state.userHasSetWeeks[2];
				const weeksToUse = userSet ? this.state.weeksToFilter2 : -1;
				this.fetchDashboard(2, weeksToUse, this.getFilterText(2));
			})
			.catch(() => {
				this.setState(prevState => ({
					gadgetLoading: { ...prevState.gadgetLoading, [gadgetNo]: false }
				}));
				toast.error('Delete failed');
			});
	}
	fileUpload_changeHandler(event) {
		this.setState(prevState => ({
			gadgetLoading: { ...prevState.gadgetLoading, 1: true }
		}));

		const uploadPromise = fileUpload(
			this,
			event,
			this.props.modelDefId,
			toast,
			httpPost,
			() => { },
			() => {
				this.setState(prevState => ({
					gadgetLoading: { ...prevState.gadgetLoading, 1: false }
				}));
			},
			ProgressEvent => { },
			() => {
				const w1 = this.state.userHasSetWeeks[1] ? this.state["weeksToFilter1"] : -1;
				this.fetchDashboard(1, w1, this.getFilterText(1));
			}
		);

		if (uploadPromise instanceof Promise) {
			uploadPromise.catch(() => {
				this.setState(prevState => ({
					gadgetLoading: { ...prevState.gadgetLoading, 1: false }
				}));
			});
		}
	}
	fileUpload_clickHandler = (event) => {
		document.getElementById("contained-button-file").click();
	}
	viewLink_clickHandler(event) {
		event.preventDefault();
		var rowId = parseInt(event.target.dataset.rowid, 10);
		var gadgetName = event.target.dataset.gadgetname;
		var rowData = this.state[gadgetName].find(d => d.rowId === rowId);
		this.setState({ openInvoiceViewer: true, invoiceDocumentFileLocation: rowData.invoiceDocumentFileLocation, showSearchTooltip: false });
	}
	scan_clickHandler(event) {
		event.preventDefault();
		const gadgetNo = event.currentTarget.dataset.gadgetnumber;
		this.setState(prevState => ({
			gadgetLoading: { ...prevState.gadgetLoading, [gadgetNo]: true }
		}));

		httpPut("/api/nonmappedinvoices/manuallyuploadedinvoices/" + event.currentTarget.dataset.documentmanualuploadrecordid)
			.then(res => {

				toast.success('File Scan in Progress');
				const w1 = this.state.userHasSetWeeks[1] ? this.state["weeksToFilter1"] : -1;
				this.fetchDashboard(1, w1, this.getFilterText(1));
			}).catch((error) => {

				this.setState(prevState => ({
					gadgetLoading: { ...prevState.gadgetLoading, [gadgetNo]: false }
				}));
				toast.error('Couldn\'t start scanning');
			});
	}
	scan_clickAIHandler(event) {
		event.preventDefault();
		const gadgetNo = event.currentTarget.dataset.gadgetnumber;
		this.setState(prevState => ({
			gadgetLoading: { ...prevState.gadgetLoading, [gadgetNo]: true }
		}));

		httpPut("/api/InvoiceDocument/aiInvoices/" + event.currentTarget.dataset.documentmanualuploadrecordid)
			.then(res => {

				toast.success('File Scan in Progress');
				const w1 = this.state.userHasSetWeeks[1] ? this.state["weeksToFilter1"] : -1;
				this.fetchDashboard(1, w1, this.getFilterText(1));
			}).catch((error) => {
				this.setState(prevState => ({
					gadgetLoading: { ...prevState.gadgetLoading, [gadgetNo]: false }
				}));
				toast.error('Couldn\'t start scanning');
			});
	}
	scanAll_clickHandler(event) {
		event.preventDefault();

		const gadgetNo = event.currentTarget.dataset.gadgetnumber;
		this.setState(prevState => ({
			gadgetLoading: { ...prevState.gadgetLoading, [gadgetNo]: true }
		}));
		if (this.scanSelectedRows.length > 0) {
			httpPost('/api/NonMappedInvoices/scanAll', this.scanSelectedRows)
				.then((response) => {

					this.scanSelectedRows = [];
					toast.success('File(s) Scan in Progress');
					this.invoiceQueueGridRef.current.setRowSelectionModel([]);
					const w1 = this.state.userHasSetWeeks[1] ? this.state["weeksToFilter1"] : -1;
					this.fetchDashboard(1, w1, this.getFilterText(1));
				}).catch((error) => {
					this.setState(prevState => ({
						gadgetLoading: { ...prevState.gadgetLoading, [gadgetNo]: false }
					}));
					toast.error('Couldn\'t start scanning');
				});
		}
		else {
			this.setState(prevState => ({
				gadgetLoading: { ...prevState.gadgetLoading, [gadgetNo]: false }
			}));
			toast.error('No invoice(s) selected for scan');
		}
	}
	openDeleteDialog(event) {
		event.preventDefault();

		const gadgetNo = parseInt(event.currentTarget.dataset.gadgetnumber, 10);
		const selectedRows = (this.scanSelectedRows || []).filter(row => row.uploadStatus !== 2);

		if (selectedRows.length === 0) {
			toast.error('No invoice(s) selected for delete');
			return;
		}

		const documentManualUploadRecordIdsToDelete = selectedRows
			.map(row => row.documentManualUploadRecordId)
			.join(',');

		this.setState({
			openDelete: true,
			documentManualUploadRecordIdsToDelete,
			deleteSelectionCount: selectedRows.length,
			deleteGadgetNumber: gadgetNo
		});
	}
	deleteYes_clickHandler(event) {
		const gadgetNo = this.state.deleteGadgetNumber || 1;
		const deleteSelectionCount = this.state.deleteSelectionCount;
		const documentManualUploadRecordIds = this.state.documentManualUploadRecordIdsToDelete;

		this.setState(prevState => ({
			openDelete: false,
			gadgetLoading: { ...prevState.gadgetLoading, [gadgetNo]: true }
		}));

		httpDelete(`/api/dashboard/queuedInvoices?companyCode=${this.companyCode}&modelDefId=${this.props.modelDefId}&documentManualUploadRecordIds=${encodeURIComponent(documentManualUploadRecordIds)}`)
			.then((response) => {
				if (!response.data) {
					throw new Error('DELETE_FAILED');
				}

				this.scanSelectedRows = [];

				if (this.invoiceQueueGridRef.current && typeof this.invoiceQueueGridRef.current.setRowSelectionModel === 'function') {
					this.invoiceQueueGridRef.current.setRowSelectionModel([]);
				}

				this.setState({
					documentManualUploadRecordIdsToDelete: '',
					deleteSelectionCount: 0
				});

				toast.success(deleteSelectionCount > 1
					? 'Invoices deleted successfully'
					: 'Invoice deleted successfully');

				const w1 = this.state.userHasSetWeeks[1] ? this.state.weeksToFilter1 : -1;
				this.fetchDashboard(1, w1, this.getFilterText(1));
			}).catch((error) => {
				this.setState(prevState => ({
					documentManualUploadRecordIdsToDelete: '',
					deleteSelectionCount: 0,
					gadgetLoading: { ...prevState.gadgetLoading, [gadgetNo]: false }
				}));
				toast.error('Delete Failed');
			});
	}
	invoiceDocumentRescan_clickHandler(event) {
		event.preventDefault();
		var rowData = this.state.queuedInvoices.find(d => d.documentManualUploadRecordId === parseInt(event.target.dataset.rowid, 10));
		const gadgetNo = event.currentTarget.dataset.gadgetnumber;
		this.setState(prevState => ({
			gadgetLoading: { ...prevState.gadgetLoading, [gadgetNo]: true }
		}));
		httpPost("/api/invoicedocument/scaninvoice/", rowData)
			.then(res => {
				toast.success('Invoice scan successfully');
				const w1 = this.state.userHasSetWeeks[1] ? this.state["weeksToFilter1"] : -1;
				this.fetchDashboard(1, w1, this.getFilterText(1));
			}).catch((error) => {
				this.setState(prevState => ({
					gadgetLoading: { ...prevState.gadgetLoading, [gadgetNo]: false }
				}));
				toast.error(<div><div>Invoice Scan Failed</div>Please contact Nexelus support for further assistance<div></div></div>,
					{ allowHtml: true });
			});
	}
	invoiceDocument_clickHandler(event) {
		event.preventDefault();
		var rowId = parseInt(event.target.dataset.rowid, 10);
		var datasource = this.state[event.target.dataset.source];
		var rowData = datasource.find(d => d.rowId === rowId);
		if (event.target.dataset.mode === 'Map Vendor') {
			this.setState({ VendorMapDialogOpen: true, rowData: rowData, isViaQueryString: false, showSearchTooltip: false });
		}
		else {
			this.setState({ openInvoiceDocumentEditorDialog: true, mode: event.target.dataset.mode, rowData: rowData, invoiceSource: event.target.dataset.source, isViaQueryString: false, showSearchTooltip: false });
		}

	}
	invoiceDocument_mapmodel_clickhandler(event) {
		event.preventDefault();
		var rowId = parseInt(event.target.dataset.rowid, 10);
		var datasource = this.state[event.target.dataset.source];
		var rowData = datasource.find(d => d.rowId === rowId);
		this.props.inProgress(true);
		httpPost("/api/invoicemodels/DuplicateInvoiceForModel", rowData)
			.then(res => {
				this.props.inProgress(false);
				if (res.data) {
					this.setState({ invoiceDocumentSampleFileLocation: res.data, openInvoiceModelSetupDialog: true, mode: event.target.dataset.mode, rowData: null });
				}
				else {
					toast.error(<div><div>Process failed</div></div>)
				}
			}).catch((error) => {
				this.props.inProgress(false);
				toast.error(<div><div>Process failed</div></div>)
			});
	}
	invoiceModelSetup_closeHandler(event) {
		this.setState({ openInvoiceModelSetupDialog: false, rowData: null });
		this.callsInProgress = 0;
	}
	suggestionFlag_clickHandler(event) {
		event.preventDefault();
		var invoiceDocumentId = parseInt(event.currentTarget.dataset.invoicedocumentid, 10);
		var isProduction = this.props.modelDefId === 2;
		this.setState({ openPOHeaderResourceDialog: !isProduction, openLevel2ResourceDialog: isProduction, invoiceDocumentId: invoiceDocumentId });
	}
	closeDialog(event) {
		this.setState({
			openDelete: false,
			openInvoiceViewer: false,
			showSearchTooltip: false,
			documentManualUploadRecordIdsToDelete: '',
			deleteSelectionCount: 0
		});
	}

	setStateAsync(state) {
		return new Promise((resolve) => {
			this.setState(state, resolve);
		});
	}


	removeInvoiceFromGadget = (gadgetNo, invoiceDocumentId) => {
		if (!invoiceDocumentId) return;

		this.setState(prev => {
			switch (gadgetNo) {

				case 2: {
					const unmatchedInvoices = prev.unmatchedInvoices.filter(
						r => r.invoiceDocumentId !== invoiceDocumentId
					);
					return {
						unmatchedInvoices,
						filteredUnmatchedInvoices: this.getFilteredUnmatchedInvoices(
							unmatchedInvoices,
							prev.selectedRoutedToResourceId
						)
					};
				}

				case 3:
					return {
						pendingApprovalInvoices: prev.pendingApprovalInvoices.filter(
							r => r.invoiceDocumentId !== invoiceDocumentId
						)
					};

				case 4:
					return {
						approvedInvoices: prev.approvedInvoices.filter(
							r => r.invoiceDocumentId !== invoiceDocumentId
						)
					};

				default:
					return null;
			}
		});
	};


	async invoiceDocumentEditor_closeHandler({
		event,
		isRoutedToEmployeeOrApproval = false,
		wasUpdate = true,
		updatedRowFieldsData = null,
		responseObject = null,
		currentStatusId = 0,
		approvalRoutingLevels = 0,
		orignalInvoiceDocumentStatusId = 0,
		isDirty = false,
		isSaved = false,
		isCompanyChanged = false,
		wasDelete = false,
		invoiceDocumentId = 0,
		isAvailableForRescaning = false,
		applyToInvoiceDocumentId = null,
		isRouteToEmployeeDialogInteraction = false,
		routeToEmployeeDialogCurrentStatusId = 0,
		routeToEmployeeDialogAction = null
	}) {
		await this.setStateAsync({ openInvoiceDocumentEditorDialog: false, rowData: null, partialSelectedRows: null, showSearchTooltip: false, invoiceSource: null });

		let _invoiceDocumentId = updatedRowFieldsData?.invoiceDocumentId ?? null;
		if (invoiceDocumentId === 0) {
			invoiceDocumentId = _invoiceDocumentId;
		}

		// --- Handle Replace Logic ---
		if (responseObject?.operation === 'replace') {
			this.removeInvoiceFromGadget(1, invoiceDocumentId);
			this.removeInvoiceFromGadget(2, invoiceDocumentId);
			this.removeInvoiceFromGadget(3, invoiceDocumentId);
			this.removeInvoiceFromGadget(4, invoiceDocumentId);
			const w1 = this.state.userHasSetWeeks[1] ? this.state["weeksToFilter1"] : -1;
			this.fetchDashboard(1, w1, this.getFilterText(1));
			return;
		}

		let allGadgetReload = true;
		const approvedStatus = (approvalRoutingLevels * 20) + 50;
		let gadgetNumber = this.getGadgetNumberByStatusId({ maxApprovalStatus: approvedStatus, currentStatusId: orignalInvoiceDocumentStatusId });

		if (wasDelete) {
			this.removeInvoiceFromGadget(gadgetNumber, invoiceDocumentId);
			return;
		}

		const getWeeksFor = (gadget) =>
			(this.state.userHasSetWeeks && this.state.userHasSetWeeks[gadget])
				? this.state['weeksToFilter' + gadget]
				: -1;

		const effectiveCurrentStatusId =
			Number(currentStatusId) > 0
				? Number(currentStatusId)
				: (Number(routeToEmployeeDialogCurrentStatusId) || 0);

		// --- Gadget 4 stale-status reconciliation on dialog close ---
		// When another user edits a gadget 4 invoice between the dashboard loading the row
		// and this user opening the editor, the grid's statusId (external) and the status
		// the editor loaded fresh from DB (orignalInvoiceDocumentStatusId / internal) differ.
		// If both statuses still belong in gadget 4, silently refresh only that row.
		// Rows that would need to move to a different grid are intentionally excluded —
		// those transitions are handled by the existing checks below.
		//
		// Statuses that keep a row in gadget 4:
		//   >= approvedStatus  →  ready to post, posted, partially posted
		//   180                →  post failed
		//
		// Guards against double-fetching with existing checks:
		//   !(isDirty && isSaved)          — Check C (line ~2165) already handles a user-saved gadget 4 row
		//   !responseObject?.reloadMode    — Check E (line ~2204) already handles POSTED_COMMENT_ONLY
		//   operation !== 'creditMemo'     — Check E (line ~2204) already handles credit memo reload
		//   !responseObject?.requiresReload — Check F (line ~2218) already handles post operations
		const staysInGadget4 = (sid) =>
			sid != null && (Number(sid) >= approvedStatus || Number(sid) === 180);

		if (
			invoiceDocumentId &&
			this.state.editorSourceOverride === 'approvedInvoices' &&
			!(isDirty && isSaved) &&
			!responseObject?.reloadMode &&
			responseObject?.operation !== 'creditMemo' &&
			!responseObject?.requiresReload
		) {
			const gridRow = (this.state.approvedInvoices || []).find(
				r => r.invoiceDocumentId === invoiceDocumentId
			);
			const gridStatusId = gridRow?.invoiceDocumentStatusId ?? null;

			if (
				gridStatusId !== null &&
				orignalInvoiceDocumentStatusId !== 0 &&
				Number(gridStatusId) !== Number(orignalInvoiceDocumentStatusId) &&
				staysInGadget4(gridStatusId) &&
				staysInGadget4(orignalInvoiceDocumentStatusId)
			) {
				allGadgetReload = false;
				this.fetchDashboard(4, getWeeksFor(4), this.getFilterText(4), false, invoiceDocumentId);
			}
		}

		if (orignalInvoiceDocumentStatusId === 40 && currentStatusId === 40 && ((isDirty && isSaved) || isRoutedToEmployeeOrApproval)) {
			allGadgetReload = false;
			this.fetchDashboard(2, getWeeksFor(2), this.getFilterText(2), false, invoiceDocumentId);
		}
		if (currentStatusId > 0 && (currentStatusId < 40 || currentStatusId === 60)) {
			allGadgetReload = false;
			this.fetchDashboard(2, getWeeksFor(2), this.getFilterText(2), false, invoiceDocumentId);
		}

		if (
			isRouteToEmployeeDialogInteraction &&
			routeToEmployeeDialogAction === 'CANCEL' &&
			!isRoutedToEmployeeOrApproval &&
			this.state.editorSourceOverride === 'unmatchedInvoices' &&
			effectiveCurrentStatusId > 40 &&
			effectiveCurrentStatusId !== 60
		) {
			allGadgetReload = false;
			this.removeInvoiceFromGadget(2, invoiceDocumentId);
			this.fetchDashboard(3, getWeeksFor(3), this.getFilterText(3), false, invoiceDocumentId, true);
		}
		if (orignalInvoiceDocumentStatusId === 40 && currentStatusId >= 50 && currentStatusId <= 70) {
			allGadgetReload = false;
			this.removeInvoiceFromGadget(2, invoiceDocumentId);
			this.fetchDashboard(3, getWeeksFor(3), this.getFilterText(3), false, invoiceDocumentId, true);
		}
		if (orignalInvoiceDocumentStatusId >= 50 && (currentStatusId === 40)) {
			allGadgetReload = false;
			this.removeInvoiceFromGadget(3, invoiceDocumentId);
			this.fetchDashboard(2, getWeeksFor(2), this.getFilterText(2), false, invoiceDocumentId);
		}

		if (currentStatusId === approvedStatus && (orignalInvoiceDocumentStatusId === 40 || (orignalInvoiceDocumentStatusId >= 50 && orignalInvoiceDocumentStatusId < approvedStatus))) {
			allGadgetReload = false;
			this.removeInvoiceFromGadget(orignalInvoiceDocumentStatusId === 40 ? 2 : 3, invoiceDocumentId);
			this.fetchDashboard(4, getWeeksFor(4), this.getFilterText(4), false, invoiceDocumentId, true);
		}

		if (currentStatusId === approvedStatus && (orignalInvoiceDocumentStatusId >= 50 && orignalInvoiceDocumentStatusId < approvedStatus)) {
			allGadgetReload = false;
			this.removeInvoiceFromGadget(3, invoiceDocumentId);
			this.fetchDashboard(4, getWeeksFor(4), this.getFilterText(4), false, invoiceDocumentId, true);
		}

		if ((orignalInvoiceDocumentStatusId >= 50 && orignalInvoiceDocumentStatusId < approvedStatus) && currentStatusId > 50 && currentStatusId < approvedStatus && orignalInvoiceDocumentStatusId !== currentStatusId) {
			allGadgetReload = false;
			this.fetchDashboard(3, getWeeksFor(3), this.getFilterText(3), false, invoiceDocumentId);
		}

		if ((orignalInvoiceDocumentStatusId >= 50 && orignalInvoiceDocumentStatusId < approvedStatus) && orignalInvoiceDocumentStatusId === currentStatusId && ((isDirty && isSaved) || isRoutedToEmployeeOrApproval)) {
			allGadgetReload = false;
			this.fetchDashboard(3, getWeeksFor(3), this.getFilterText(3), false, invoiceDocumentId);
		}		

		const validStatuses = [80, 100, 120, 140, 160];
		const isCurrentValid = validStatuses.includes(Number(currentStatusId));
		const isOriginalValid = validStatuses.includes(Number(orignalInvoiceDocumentStatusId));
		if (orignalInvoiceDocumentStatusId >= 50 && currentStatusId > 50 && (isCurrentValid || isOriginalValid) && ((orignalInvoiceDocumentStatusId !== currentStatusId) || isRoutedToEmployeeOrApproval)) {
			allGadgetReload = false;
			this.fetchDashboard(3, getWeeksFor(3), this.getFilterText(3), false, invoiceDocumentId);
		}

		if (orignalInvoiceDocumentStatusId === approvedStatus && isDirty && isSaved) {
			allGadgetReload = false;
			this.fetchDashboard(4, getWeeksFor(4), this.getFilterText(4), false, invoiceDocumentId);
		}

		if (orignalInvoiceDocumentStatusId === 180 && currentStatusId <= 50) {
			allGadgetReload = false;
			this.removeInvoiceFromGadget(4, invoiceDocumentId);

			let targetGadget = null;
			let gadgetName = null;
			if (currentStatusId === 60 || (currentStatusId >= 10 && currentStatusId <= 40)) {
				targetGadget = 2; // Unmatched/Discrepant
				gadgetName = "unmatchedInvoices";
			} else if (currentStatusId >= 50 && currentStatusId < approvedStatus) {
				targetGadget = 3; // Pending Approval
				gadgetName = "pendingApprovalInvoices";
			}

			if (targetGadget) {
				if (responseObject) {
					let rows = this.state[gadgetName];
					let updatedRows = this.upsertInvoiceRow(rows, [responseObject], responseObject.invoiceDocumentId);
					this.setState({ [gadgetName]: updatedRows });
				} else {
					this.fetchDashboard(
						targetGadget,
						getWeeksFor(targetGadget),
						this.getFilterText(targetGadget),
						false,
						invoiceDocumentId,
						true
					);
				}
			}
		}

		if (responseObject?.reloadMode === "POSTED_COMMENT_ONLY" || responseObject?.operation === "creditMemo") {
			allGadgetReload = false;
			this.fetchDashboard(4, getWeeksFor(4), this.getFilterText(4), false, invoiceDocumentId);
		}

		if (isCompanyChanged) {
			if (currentStatusId <= 40) {
				allGadgetReload = false;
				this.removeInvoiceFromGadget(2, invoiceDocumentId);
			} else if (currentStatusId >= 50 && currentStatusId < approvedStatus) {
				allGadgetReload = false;
				this.removeInvoiceFromGadget(3, invoiceDocumentId);
			}
		}
		if (responseObject?.requiresReload) {
			allGadgetReload = false;
			// Simulate loading for 1 second to allow the post operation to fully
			// propagate on the DB side before fetching the fresh row.
			this.setState(prev => ({
				rowReloading: { ...prev.rowReloading, [invoiceDocumentId]: true },
				highlightedInvoiceDocumentId: invoiceDocumentId
			}));
			setTimeout(() => {
				this.fetchDashboard(4, getWeeksFor(4), this.getFilterText(4), false, invoiceDocumentId, false, isAvailableForRescaning, applyToInvoiceDocumentId);
			}, 1000);
		}
		if (wasUpdate && allGadgetReload && invoiceDocumentId) {
			const originalGadgetNo = this.getGadgetNumberByStatusId({
				maxApprovalStatus: approvedStatus,
				currentStatusId: orignalInvoiceDocumentStatusId
			});

			const currentGadgetNo = this.getGadgetNumberByStatusId({
				maxApprovalStatus: approvedStatus,
				currentStatusId: currentStatusId
			});

			if (originalGadgetNo && currentGadgetNo) {
				allGadgetReload = false;

				if (originalGadgetNo === currentGadgetNo) {
					this.fetchDashboard(
						currentGadgetNo,
						getWeeksFor(currentGadgetNo),
						this.getFilterText(currentGadgetNo),
						false,
						invoiceDocumentId
					);
				} else {
					this.removeInvoiceFromGadget(originalGadgetNo, invoiceDocumentId);
					this.fetchDashboard(currentGadgetNo, getWeeksFor(currentGadgetNo), this.getFilterText(currentGadgetNo),	false, invoiceDocumentId, true);
				}
			}
		}

		if (responseObject?.invoiceIndicator === 2) {
			await this.setStateAsync({
				openInvoiceDocumentEditorDialog: true,
				mode: Constants.CREDIT_MEMO,
				rowData: responseObject
			});
		}
		if (
			responseObject?.openLinkedInvoice === true &&
			responseObject?.invoiceDocumentId
		) {
			const isCreditMemo = responseObject.invoiceIndicator === 2;

			await this.setStateAsync({
				openInvoiceDocumentEditorDialog: true,
				mode: isCreditMemo ? Constants.CREDIT_MEMO : Constants.VIEW,
				rowData: {
					invoiceDocumentId: responseObject.invoiceDocumentId
				},
				isViaQueryString: false
			});
			return;
		}

		if (wasUpdate && allGadgetReload) {
			this.fetchDashboard(2, getWeeksFor(2), this.getFilterText(2));
			this.fetchDashboard(3, getWeeksFor(3), this.getFilterText(3));
			this.fetchDashboard(4, getWeeksFor(4), this.getFilterText(4));
		}

		this.setState(
			{ highlightedInvoiceDocumentId: null },
			() => {
				this.setState({
					highlightedInvoiceDocumentId: invoiceDocumentId
				});
			}
		);
	}
	getGadgetNumberByStatusId({ maxApprovalStatus = null, currentStatusId = null }) {
		if (!currentStatusId || currentStatusId <= 0) return null;

		let normalizedStatusId = currentStatusId;

		// Normalize status:
		// If status % 20 === 0 → subtract 30
		// e.g. 40 → 10, 60 → 30, 80 → 50
		if (normalizedStatusId % 20 === 0) {
			normalizedStatusId = normalizedStatusId - 30;
		}

		// Gadget 2:
		// status between 10 and 40 OR status is 60
		if (
			(normalizedStatusId >= 10 && normalizedStatusId <= 40) ||
			currentStatusId === 60
		) {
			return 2;
		}

		// Gadget 3:
		// status >= 50, not 60, and below maxApprovalStatus
		if (
			normalizedStatusId >= 50 &&
			currentStatusId !== 60 &&
			maxApprovalStatus !== null &&
			normalizedStatusId < maxApprovalStatus
		) {
			return 3;
		}

		// Gadget 4:
		// status >= maxApprovalStatus
		if (
			maxApprovalStatus !== null &&
			normalizedStatusId >= maxApprovalStatus
		) {
			return 4;
		}

		return null;
	}

	async vendorMapDialog_closeHandler(event, wasUpdated = true) {
		if (event?.reopenInvoice === true && event?.invoiceDocumentId) {
			this.setState({
				VendorMapDialogOpen: false,
				rowData: null,
				openInvoiceDocumentEditorDialog: true,
				rowData: {
					invoiceDocumentId: event.invoiceDocumentId
				},
				isViaQueryString: false
			});

			if (wasUpdated) {
				await this.fetchAllDashboardData();
			}

			return;
		}

		this.setState({ VendorMapDialogOpen: false, rowData: null });

		if (wasUpdated) {
			//this.fetchDashboard(this.state.showGadget, this.state[`weeksToFilter${this.state.showGadget}`], this.getFilterText(this.state.showGadget));
			this.fetchDashboard(2, this.state.userHasSetWeeks[2] ? weeks2 : -1, this.getFilterText(2));
		}
	}


	handleDragOver(event) {
		event.preventDefault();
		if (this.isCursorInsideDragArea(event)) {
			this.setState({ dragging: true });
		}
	}
	handleDragLeave(event) {
		event.preventDefault();
		if (!this.isCursorInsideDragArea(event)) {
			this.setState({ dragging: false });
		}
	}
	handleDrop(event) {
		event.preventDefault();
		this.setState({ dragging: false });
		const files = event.dataTransfer.files;
		this.fileUpload_changeHandler({ target: { files } });
	}
	isCursorInsideDragArea(event) {
		const dragArea = document.querySelector('.drag_area');
		const rect = dragArea.getBoundingClientRect();
		const x = event.clientX;
		const y = event.clientY;
		return (
			x >= rect.left &&
			x <= rect.right &&
			y >= rect.top &&
			y <= rect.bottom
		);
	}
	//#endregion
	//#Link Region
	getDiscrepentInvoiceLink(rowData) {
		let text = 'Make Corrections';
		let datamode = 'MakeCorrections';
		if (rowData.row.invoiceDocumentStatusId === 10 && rowData.row.vendorMappingId && rowData.row.scanServiceId === 0) {
			text = 'Map Vendor';
			datamode = 'Map Vendor'
		}
		else if (rowData.row.invoiceDocumentStatusId === 10 && !rowData.row.vendorMappingId) {
			return (
				<div>
					<Link data-rowid={rowData.row.rowId} data-source="unmatchedInvoices" data-mode={datamode} href="#" onClick={this.invoiceDocument_clickHandler}>{text}</Link> /&nbsp;
					<Link data-rowid={rowData.row.rowId} data-source="unmatchedInvoices" data-mode={'NewSample'} href="#" onClick={this.invoiceDocument_mapmodel_clickhandler}>
						<Tooltip key={'modeleditorkey' + rowData.row.rowId} data-rowid={rowData.row.rowId} data-source="unmatchedInvoices" data-mode={'NewSample'}
							title={'Please create a model for this invoice and re-upload it for processing. Alternatively, manually update the invoice information.'} >
							<Typography variant="inherit">Map Model</Typography>
						</Tooltip>
					</Link>


				</div>
			);
		}
		return <Link data-rowid={rowData.row.rowId} data-source="unmatchedInvoices" data-mode={datamode} href="#" onClick={this.invoiceDocument_clickHandler}>{text}</Link>
	}
	inProgress(value, uploading, loaded, invoiceDocumentSampleFileLocation) {
		if (!uploading) {
			if (value === true) {
				this.callsInProgress++;
			}
			else if (value === false) {
				if (this.callsInProgress > 0) {
					this.callsInProgress--;
				}

				if (this.callsInProgress === 0) {
					if (invoiceDocumentSampleFileLocation) {
						this.setState({ invoiceDocumentSampleFileLocation: invoiceDocumentSampleFileLocation });
					}
				}
			}
		}

		return this.props.inProgress(value, uploading, loaded);
	}
	setFilterText(gadgetNumber, text) {
		const weeksForGadget = this.state[`weeksToFilter${gadgetNumber}`];
		const isNoFilter = weeksForGadget === 0;
		const prevText = this.state.filterText[gadgetNumber];

		this.setState(prev => ({
			filterText: {
				...prev.filterText,
				[gadgetNumber]: text,
			},
			...(text !== prev.filterText[gadgetNumber] && {
				prevSearchText: {
					...prev.prevSearchText,
					[gadgetNumber]: ''
				}
			})
		}), () => {
			const moduleKey = getInvoiceModuleName(this.props.modelDefId);

			if (isNoFilter) {
				// ✅ In NoFilter mode: typing/clearing should NOT change persisted filters.
				// The only place that modifies stored filters for NoFilter is the Search button.
				return;
			}

			// ✅ For other weeks keep existing behavior: persist weeks + text
			//setFilter(
			//	[moduleKey, 'Dashboard', `weeksToFilter${gadgetNumber}`],
			//	weeksForGadget
			//);

			if (text !== '') {
				setFilter(
					[moduleKey, 'Dashboard', `searchText${gadgetNumber}`],
					text
				);
			} else {
				setFilter(
					[moduleKey, 'Dashboard', `searchText${gadgetNumber}`],
					''
				);
			}
		});
	}

	getFilterText(gadgetNumber) {
		var text = this.state.filterText[gadgetNumber] || '';
		return text;
	}

	handleSearchFocus(gadgetNumber) {
		const isNoFilter = this.state[`weeksToFilter${gadgetNumber}`] === 0;
		const hasText = this.getFilterText(gadgetNumber)?.trim().length > 0;
		const isDefaultDbNoFilter = this.state.isDefaultDBNoFilter[gadgetNumber];

		if (
			isNoFilter &&
			hasText &&
			!isDefaultDbNoFilter &&
			!this.state.switchToFullScreen
		) {
			const screenState = this.getFullScreenState(gadgetNumber);
			this.setState({
				...screenState,
			}, () => {
				const gridRef = this.getGridRef(gadgetNumber)?.current;
				if (gridRef && typeof gridRef.setQuickFilterValues === 'function') {
					gridRef.setQuickFilterValues([this.getFilterText(gadgetNumber)]);
				}

			});
			//const weeks = this.state[`weeksToFilter${gadgetNumber}`];
			//const searchText = this.getFilterText(gadgetNumber);
			//this.fetchDashboard(gadgetNumber, weeks, searchText, false);
		}
	}


	getSearchButton(gadgetNumber) {

		const weekFilter = this.state[`weeksToFilter${gadgetNumber}`];
		const isDefaultDbNoFilter = this.state.isDefaultDBNoFilter[gadgetNumber];

		if (weekFilter !== 0 || (weekFilter == 0 && isDefaultDbNoFilter)) return null;

		if (this.state.showGadget === gadgetNumber && this.state.switchToFullScreen) {
			return (
				<Button
					startIcon={<SearchIcon />}
					color="primary"
					size="medium"
					sx={{
						backgroundColor: '#008ecd',
						border: '1px solid #008ecd',
						borderRadius: '6px',
						color: 'white !important',
						fontSize: '0.8rem !important',
						fontFamily: 'Lato, sans-serif',
						cursor: 'pointer',
						marginTop: '10px',
						marginRight: '14px',
						marginLeft: '1px',
						marginBottom: '0px',
						paddingTop: '4px',
						paddingBottom: '5px',
						paddingLeft: '11px',
						paddingRight: '9px',
						width: '100px',
						textTransform: 'none',
						'&:hover': {
							backgroundColor: '#007cb5',
							borderColor: '#007cb5',
						}
					}}
					onClick={() => {

						const text = this.state.filterText[gadgetNumber];
						if (!text) {
							toast.error("Search input is required to proceed");
							return;
						}

						this.setState(prev => ({
							prevSearchText: {
								...prev.prevSearchText,
								[gadgetNumber]: text
							}
						}), () => {
							if (text !== '') {
								setFilter([getInvoiceModuleName(this.props.modelDefId), 'Dashboard', `searchText${gadgetNumber}`], this.state.filterText[gadgetNumber]);
								setFilter([getInvoiceModuleName(this.props.modelDefId), 'Dashboard', `weeksToFilter${gadgetNumber}`], this.state[`weeksToFilter${gadgetNumber}`]);
							} else {
								setFilter([getInvoiceModuleName(this.props.modelDefId), 'Dashboard', `searchText${gadgetNumber}`], '');
								setFilter([getInvoiceModuleName(this.props.modelDefId), 'Dashboard', `weeksToFilter${gadgetNumber}`], '');
							}
							this.fetchDashboard(
								gadgetNumber,
								this.state['weeksToFilter' + gadgetNumber],
								this.state.filterText[gadgetNumber] || ''
							);
						});

					}}
				>
					Search
				</Button>
			);
		}

		return null;
	}



	getGridRef(gadgetNumber) {
		let ref;
		switch (gadgetNumber) {
			case 1: {
				ref = this.invoiceQueueGridRef;
				break;
			}
			case 2: {
				ref = this.invoiceUnmatchedGridRef;
				break;
			}
			case 3: {
				ref = this.invoicePendingApprovalGridRef;
				break;
			}
			case 4: {
				ref = this.invoiceApprovedGridRef;
				break;
			}
		}
		return ref;
	}
	//endregion


	render() {
		const info = {
			modelDefId: this.props.modelDefId,
			invoiceDocumentFileLocation: this.state.invoiceDocumentFileLocation,
			inProgress: this.props.inProgress,
			onClose: this.closeDialog
		}

		const invoiceModelEditorInfo = {
			rowData: this.state.rowData,
			mode: this.state.mode,
			inProgress: this.inProgress,
			modelDefId: this.props.modelDefId,
			from: Constants.DASHBOARD,
			invoiceDocumentSampleFileLocation: this.state.invoiceDocumentSampleFileLocation
		}
		const InvoiceDocumentEditorInfo = {
			rowData: this.state.rowData,
			mode: this.state.mode,
			invoiceSource: this.state.invoiceSource,
			modelDefId: this.props.modelDefId,
			isViaQueryString: this.state.isViaQueryString,
			toggleFavoriteStatus: this.toggleFavoriteStatus,
			inProgress: this.props.inProgress,
			editorSource: this.state?.editorSourceOverride === '1' ? null : Constants.SOURCE_DASHBOARD_GADGET
		}
		const poHeaderResourceInfo = {
			inProgress: this.props.inProgress,
			openDialog: this.state.openPOHeaderResourceDialog,
			vendorCode: null,
			siteId: null,
			invoiceDocumentId: this.state.invoiceDocumentId
		};
		const level2ResourceInfo = {
			inProgress: this.props.inProgress,
			openDialog: this.state.openLevel2ResourceDialog,
			vendorCode: null,
			siteId: null,
			invoiceDocumentId: this.state.invoiceDocumentId
		};
		const clientInfo = {
			modelDefId: this.props.modelDefId,
			inProgress: this.props.inProgress,
			onClose: this.closeDialog
		};


		const showGrid1 = this.state.showGadget == 1 || this.state.showGadget == 0;
		const showGrid2 = this.state.showGadget == 2 || this.state.showGadget == 0;
		const showGrid3 = this.state.showGadget == 3 || this.state.showGadget == 0;
		const showGrid4 = this.state.showGadget == 4 || this.state.showGadget == 0;

		const grid1 = this.state.showGadget == 1;
		const grid2 = this.state.showGadget == 2;
		const grid3 = this.state.showGadget == 3;
		const grid4 = this.state.showGadget == 4;

		// The four gadgets, rendered the same way in both UIs. The new UI passes a view of this component (`ref`) whose
		// state lists only the chosen queue's rows; Classic always passes `this`.
		const renderGadgets = (ref) => (

				<Grid container style={{ flexGrow: 1 }} spacing={spacing}>
					<Grid item xs={12}>
						<Grid container justify="center" spacing={spacing}>

							{showGrid1 ?
								<TopLeftGadget
									xsVal={this.state.switchToFullScreen ? 12 : 6}
									gridCss={this.state.switchToFullScreen ? gridCssFullScreen : gridCss}
									keyVal={this.state.switchToFullScreen ? 1 : 2}
									thisRef={ref}
									fontSize={fontSize}
									fontStyle={fontStyle}
									cellStyle={cellStyle}
									headerStyle={headerStyle}
									hasSearchedOnce={this.state.hasSearchedOnceByUser[1]}

								/>
								:
								null
							}
							{showGrid2 ?
								<TopRightGadget
									xsVal={this.state.switchToFullScreen ? 12 : 6}
									gridCss={this.state.switchToFullScreen ? gridCssFullScreen : gridCss}
									keyVal={this.state.switchToFullScreen ? 3 : 4}
									thisRef={ref}
									fontStyle={fontStyle}
									cellStyle={cellStyle}
									hasSearchedOnce={this.state.hasSearchedOnceByUser[2]}

								/>
								:
								null
							}
						</Grid>
					</Grid>
					<Grid item xs={12}>
						{/*<Grid container justify="center" spacing={spacing}>*/}
						{/*	{showGrid3 && this.props.modelDefId !== 3 ?*/}
						{/*		grid3 ?*/}
						{/*			this.getBottomLeftGrid(12, gridCssFullScreen, 5) : this.getBottomLeftGrid(6, gridCss, 6)*/}
						{/*		:*/}
						{/*		null*/}
						{/*	}{showGrid4 ?*/}
						{/*		grid4 || this.props.modelDefId === 3 ?*/}
						{/*			this.getBottomRightGrid(12, gridCssFullScreen, 7) : this.getBottomRightGrid(this.props.modelDefId === 3 ? 12 : 6, gridCss, 8)*/}
						{/*		:*/}
						{/*		null*/}
						{/*	}*/}

						{/*</Grid>*/}
						<Grid container justify="center" spacing={spacing}>
							{
								showGrid3 ?


									<BottomLeftGadget
										xsVal={this.state.switchToFullScreen ? 12 : 6}
										gridCss={this.state.switchToFullScreen ? gridCssFullScreen : gridCss}
										keyVal={this.state.switchToFullScreen ? 5 : 6}
										thisRef={ref}
										fontStyle={fontStyle}
										cellStyle={cellStyle}
										hasSearchedOnce={this.state.hasSearchedOnceByUser[3]}

									/>


									: null
							}
							{
								showGrid4 ?
									<BottomRightGadget
										xsVal={this.state.switchToFullScreen ? 12 : 6}
										gridCss={this.state.switchToFullScreen ? gridCssFullScreen : gridCss}
										keyVal={this.state.switchToFullScreen ? 7 : 8}
										thisRef={ref}
										fontStyle={fontStyle}
										cellStyle={cellStyle}
										hasSearchedOnce={this.state.hasSearchedOnceByUser[4]}

									/>
									: null
							}

						</Grid>
					</Grid>
				</Grid>
		);

		return (
			<div>
				{/* New UI: the pipeline summary sits above the same four classic gadgets; state, handlers and dialogs are shared. */}
				{isNewUi() ? <DashboardPipeline thisRef={this} renderGadgets={renderGadgets} /> : <React.Fragment>
				<h1>{this.props.modelDefId === 1 ? 'Media' : (this.props.modelDefId === 2 ? 'Production' : 'Broadcast')} Invoices Dashboard</h1>
				{renderGadgets(this)}
				</React.Fragment>}
				<Dialog
					open={this.state.openDelete}
					aria-labelledby="draggable-dialog-title"
				>
					<DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
						Delete
					</DialogTitle>
					<DialogContent>
						<DialogContentText>
							{this.state.deleteSelectionCount > 1
								? `Are you sure you want to delete these ${this.state.deleteSelectionCount} invoices?`
								: 'Are you sure you want to delete this invoice?'}
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button onClick={this.deleteYes_clickHandler} color="primary">
							Yes
						</Button>
						<Button autoFocus onClick={this.closeDialog} color="primary">
							No
						</Button>
					</DialogActions>
				</Dialog>
				<Dialog
					open={this.state.openInvoiceViewer}
					aria-labelledby="draggable-dialog-title"
					TransitionComponent={Transition}
					fullwidth={true}
					maxWidth="lg"
				>
					<DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
						Invoice Document
					</DialogTitle>
					<DialogContent style={{ maxWidth: 750 }}>
						<InvoiceDocumentViewer info={info} clientInfo={clientInfo} />
					</DialogContent>
					<DialogActions>
						<Button autoFocus onClick={this.closeDialog} color="primary">
							Close
						</Button>
					</DialogActions>
				</Dialog>
				{
					this.state.openInvoiceDocumentEditorDialog &&
					<Dialog open={this.state.openInvoiceDocumentEditorDialog} TransitionComponent={Transition} fullScreen>
						<InvoiceDocumentEditor info={InvoiceDocumentEditorInfo} clientInfo={clientInfo} partialSelectedRows={this.state.mode === "PartialPost" ? this.state.partialSelectedRows : null} onClose={this.invoiceDocumentEditor_closeHandler} fetchDashboard={(gadgetNo, weeks) => this.fetchDashboard(gadgetNo, weeks)} />
					</Dialog>
				}

				<POHeaderResourceLookup info={{ ...poHeaderResourceInfo, userRoleName: this.state.userRoleName, source: this.state.source }} onClose={this.poHeaderResourceDialog_closeHandler} />
				<Level2ResourceLookup info={{ ...level2ResourceInfo, userRoleName: this.state.userRoleName, source: this.state.source }} onClose={this.level2ResourceDialog_closeHandler} />
				<VendorMapEditorDetailDialog
					isOpen={this.state.VendorMapDialogOpen}
					forceVendorMapPrompt={true}
					info={{
						modelDefId: this.props.modelDefId,
						inProgress: this.props.inProgress,
						invoiceDocument: this.state.rowData
					}}
					onClose={this.vendorMapDialog_closeHandler}
				></VendorMapEditorDetailDialog>
				<Dialog fullScreen open={this.state.openInvoiceModelSetupDialog} TransitionComponent={Transition}>
					<InvoiceModelSetup info={invoiceModelEditorInfo} onClose={this.invoiceModelSetup_closeHandler} />
				</Dialog>

				<Dialog
					open={this.state.openCreditMemoRepostDialog}
					onClose={() => this.setState({ openCreditMemoRepostDialog: false, creditMemoRowForRepost: null, applyToInvoiceDocumentId: null })}
					TransitionComponent={Transition}
				>
					<DialogTitle>Rescan Original Invoice</DialogTitle>
					<DialogContent>
						<DialogContentText>
							Do you want to rescan the original invoice as well?
						</DialogContentText>
					</DialogContent>
					<DialogActions>

						<Button
							onClick={async () => {
								const row = this.state.creditMemoRowForRepost;
								const creditMemoId = row?.invoiceDocumentId;
								const companyCode = this.companyCode;
								const originalInvoiceId = this.state?.applyToInvoiceDocumentId;

								if (!creditMemoId) return;
								this.props.inProgress(true);
								try {
									if (originalInvoiceId > 0) {
										await httpPost("/api/invoicedocument/rescanoriginalinvoice", {
											companyCode: companyCode,
											modelDefId: this.props.modelDefId,
											applyToInvoiceDocumentId: originalInvoiceId
										});
										toast.success('Invoice sent for rescan');
									}
									this.setState({ openCreditMemoRepostDialog: false, creditMemoRowForRepost: null, applyToInvoiceDocumentId: null });
								}
								catch {
									toast.error('Rescaning invoice failed');
								}
								this.props.inProgress(false);
							}}
						>
							Yes
						</Button>
						<Button
							onClick={async () => {
								this.setState({ openCreditMemoRepostDialog: false, creditMemoRowForRepost: null, applyToInvoiceDocumentId: null });
							}}
						>
							Cancel
						</Button>
					</DialogActions>
				</Dialog>

				{this.state.openPartialPostDialog && (
					<InvoiceDocumentPartialPostLookup
						invoiceDocumentId={this.state.partialPostInvoiceDocumentId}
						canEdit={this.state.repostRuleEditable}
						onEdit={(selectedRows) => {
							// Transition from partial post dialog to the full editor in PartialPost mode.
							// partialSelectedRows is kept as its own state key so the editor
							// receives it as a top-level prop (props.partialSelectedRows), matching
							// the same contract as InvoiceDocument.
							const row = this.state.partialPostRow;
							this.setState(
								{ openPartialPostDialog: false, partialPostInvoiceDocumentId: null, partialPostRow: null },
								() => {
									if (!row) return;
									this.setState({
										openInvoiceDocumentEditorDialog: true,
										mode: 'PartialPost',
										rowData: {
											invoiceDocumentId: row.invoiceDocumentId,
											invoiceSource: row.invoiceSource
										},
										partialSelectedRows: selectedRows,
										invoiceSource: 'approvedInvoices',
										isViaQueryString: false,
										showSearchTooltip: false,
										editorSourceOverride: 'approvedInvoices',
									});
								}
							);
						}}
						mode={this.state.partialPostDialogMode}
						modelDefId={this.props.modelDefId}
						inProgress={this.props.inProgress}
						onClose={(shouldRefresh = false) => {
							const invoiceDocumentId = this.state.partialPostInvoiceDocumentId;
							this.setState(
								{ openPartialPostDialog: false, partialPostInvoiceDocumentId: null, partialPostRow: null, partialPostDialogMode: 'view', partialSelectedRows: null },
								() => {
									if (shouldRefresh && invoiceDocumentId) {
										const weeksToUse = this.state.userHasSetWeeks?.[4] ? (this.state.weeksToFilter4 ?? 0) : -1;
										const searchText = this.getFilterText(4) || '';
										this.fetchDashboard(4, weeksToUse, searchText, false, invoiceDocumentId);
									}
								}
							);
						}}
						onView={() => {
							// Open the editor in normal View mode — partialSelectedRows must be
							// explicitly cleared so the editor does not enter PartialPost variant.
							const row = this.state.partialPostRow;
							this.setState(
								{ openPartialPostDialog: false, partialPostInvoiceDocumentId: null, partialPostRow: null, partialSelectedRows: null },
								() => {
									if (!row) return;
									this.openInvoiceFromRow(row, 'approvedInvoices', 'View');
								}
							);
						}}
					/>
				)}
			</div>
		);
	}
}